export const cityData = {
	'RECORDS': [
		{
			'id': '152900',
			'name': '阿拉善盟',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '阿拉善盟',
			'leveltype': 2,
			'citycode': '0483',
			'zipcode': '750306',
			'mergername': '中国,内蒙古自治区,阿拉善盟',
			'lng': '105.706422',
			'lat': '38.844814',
			'pinyin': 'Alxa',
			'initial': 'A'
		},
		{
			'id': '210300',
			'name': '鞍山市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '鞍山',
			'leveltype': 2,
			'citycode': '0412',
			'zipcode': '114001',
			'mergername': '中国,辽宁省,鞍山市',
			'lng': '122.995632',
			'lat': '41.110626',
			'pinyin': 'Anshan',
			'initial': 'A'
		},
		{
			'id': '340800',
			'name': '安庆市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '安庆',
			'leveltype': 2,
			'citycode': '0556',
			'zipcode': '246001',
			'mergername': '中国,安徽省,安庆市',
			'lng': '117.053571',
			'lat': '30.524816',
			'pinyin': 'Anqing',
			'initial': 'A'
		},
		{
			'id': '410500',
			'name': '安阳市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '安阳',
			'leveltype': 2,
			'citycode': '0372',
			'zipcode': '455000',
			'mergername': '中国,河南省,安阳市',
			'lng': '114.352482',
			'lat': '36.103442',
			'pinyin': 'Anyang',
			'initial': 'A'
		},
		{
			'id': '513200',
			'name': '阿坝藏族羌族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '阿坝',
			'leveltype': 2,
			'citycode': '0837',
			'zipcode': '624000',
			'mergername': '中国,四川省,阿坝藏族羌族自治州',
			'lng': '102.221374',
			'lat': '31.899792',
			'pinyin': 'Aba',
			'initial': 'A'
		},
		{
			'id': '520400',
			'name': '安顺市',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '安顺',
			'leveltype': 2,
			'citycode': '0853',
			'zipcode': '561000',
			'mergername': '中国,贵州省,安顺市',
			'lng': '105.932188',
			'lat': '26.245544',
			'pinyin': 'Anshun',
			'initial': 'A'
		},
		{
			'id': '610900',
			'name': '安康市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '安康',
			'leveltype': 2,
			'citycode': '0915',
			'zipcode': '725000',
			'mergername': '中国,陕西省,安康市',
			'lng': '109.029273',
			'lat': '32.6903',
			'pinyin': 'Ankang',
			'initial': 'A'
		},
		{
			'id': '652900',
			'name': '阿克苏地区',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '阿克苏',
			'leveltype': 2,
			'citycode': '0997',
			'zipcode': '843000',
			'mergername': '中国,新疆维吾尔自治区,阿克苏地区',
			'lng': '80.265068',
			'lat': '41.170712',
			'pinyin': 'Aksu',
			'initial': 'A'
		},
		{
			'id': '654300',
			'name': '阿勒泰地区',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '阿勒泰',
			'leveltype': 2,
			'citycode': '0906',
			'zipcode': '836500',
			'mergername': '中国,新疆维吾尔自治区,阿勒泰地区',
			'lng': '88.13963',
			'lat': '47.848393',
			'pinyin': 'Altay',
			'initial': 'A'
		},
		{
			'id': '110100',
			'name': '北京市',
			'areacode': null,
			'areaname': null,
			'pid': '110000',
			'shortname': '北京',
			'leveltype': 2,
			'citycode': '010',
			'zipcode': '100000',
			'mergername': '中国,北京,北京市',
			'lng': '116.405285',
			'lat': '39.904989',
			'pinyin': 'Beijing',
			'initial': 'B'
		},
		{
			'id': '130600',
			'name': '保定市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '保定',
			'leveltype': 2,
			'citycode': '0312',
			'zipcode': '071052',
			'mergername': '中国,河北省,保定市',
			'lng': '115.482331',
			'lat': '38.867657',
			'pinyin': 'Baoding',
			'initial': 'B'
		},
		{
			'id': '150200',
			'name': '包头市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '包头',
			'leveltype': 2,
			'citycode': '0472',
			'zipcode': '014025',
			'mergername': '中国,内蒙古自治区,包头市',
			'lng': '109.840405',
			'lat': '40.658168',
			'pinyin': 'Baotou',
			'initial': 'B'
		},
		{
			'id': '150800',
			'name': '巴彦淖尔市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '巴彦淖尔',
			'leveltype': 2,
			'citycode': '0478',
			'zipcode': '015001',
			'mergername': '中国,内蒙古自治区,巴彦淖尔市',
			'lng': '107.416959',
			'lat': '40.757402',
			'pinyin': 'Bayan Nur',
			'initial': 'B'
		},
		{
			'id': '210500',
			'name': '本溪市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '本溪',
			'leveltype': 2,
			'citycode': '0414',
			'zipcode': '117000',
			'mergername': '中国,辽宁省,本溪市',
			'lng': '123.770519',
			'lat': '41.297909',
			'pinyin': 'Benxi',
			'initial': 'B'
		},
		{
			'id': '220600',
			'name': '白山市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '白山',
			'leveltype': 2,
			'citycode': '0439',
			'zipcode': '134300',
			'mergername': '中国,吉林省,白山市',
			'lng': '126.427839',
			'lat': '41.942505',
			'pinyin': 'Baishan',
			'initial': 'B'
		},
		{
			'id': '220800',
			'name': '白城市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '白城',
			'leveltype': 2,
			'citycode': '0436',
			'zipcode': '137000',
			'mergername': '中国,吉林省,白城市',
			'lng': '122.841114',
			'lat': '45.619026',
			'pinyin': 'Baicheng',
			'initial': 'B'
		},
		{
			'id': '340300',
			'name': '蚌埠市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '蚌埠',
			'leveltype': 2,
			'citycode': '0552',
			'zipcode': '233000',
			'mergername': '中国,安徽省,蚌埠市',
			'lng': '117.36237',
			'lat': '32.934037',
			'pinyin': 'Bengbu',
			'initial': 'B'
		},
		{
			'id': '341600',
			'name': '亳州市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '亳州',
			'leveltype': 2,
			'citycode': '0558',
			'zipcode': '236802',
			'mergername': '中国,安徽省,亳州市',
			'lng': '115.782939',
			'lat': '33.869338',
			'pinyin': 'Bozhou',
			'initial': 'B'
		},
		{
			'id': '371600',
			'name': '滨州市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '滨州',
			'leveltype': 2,
			'citycode': '0543',
			'zipcode': '256619',
			'mergername': '中国,山东省,滨州市',
			'lng': '118.016974',
			'lat': '37.383542',
			'pinyin': 'Binzhou',
			'initial': 'B'
		},
		{
			'id': '450500',
			'name': '北海市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '北海',
			'leveltype': 2,
			'citycode': '0779',
			'zipcode': '536000',
			'mergername': '中国,广西壮族自治区,北海市',
			'lng': '109.119254',
			'lat': '21.473343',
			'pinyin': 'Beihai',
			'initial': 'B'
		},
		{
			'id': '451000',
			'name': '百色市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '百色',
			'leveltype': 2,
			'citycode': '0776',
			'zipcode': '533000',
			'mergername': '中国,广西壮族自治区,百色市',
			'lng': '106.616285',
			'lat': '23.897742',
			'pinyin': 'Baise',
			'initial': 'B'
		},
		{
			'id': '511900',
			'name': '巴中市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '巴中',
			'leveltype': 2,
			'citycode': '0827',
			'zipcode': '636000',
			'mergername': '中国,四川省,巴中市',
			'lng': '106.753669',
			'lat': '31.858809',
			'pinyin': 'Bazhong',
			'initial': 'B'
		},
		{
			'id': '520500',
			'name': '毕节市',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '毕节',
			'leveltype': 2,
			'citycode': '0857',
			'zipcode': '551700',
			'mergername': '中国,贵州省,毕节市',
			'lng': '105.28501',
			'lat': '27.301693',
			'pinyin': 'Bijie',
			'initial': 'B'
		},
		{
			'id': '530500',
			'name': '保山市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '保山',
			'leveltype': 2,
			'citycode': '0875',
			'zipcode': '678000',
			'mergername': '中国,云南省,保山市',
			'lng': '99.167133',
			'lat': '25.111802',
			'pinyin': 'Baoshan',
			'initial': 'B'
		},
		{
			'id': '610300',
			'name': '宝鸡市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '宝鸡',
			'leveltype': 2,
			'citycode': '0917',
			'zipcode': '721000',
			'mergername': '中国,陕西省,宝鸡市',
			'lng': '107.14487',
			'lat': '34.369315',
			'pinyin': 'Baoji',
			'initial': 'B'
		},
		{
			'id': '620400',
			'name': '白银市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '白银',
			'leveltype': 2,
			'citycode': '0943',
			'zipcode': '730900',
			'mergername': '中国,甘肃省,白银市',
			'lng': '104.173606',
			'lat': '36.54568',
			'pinyin': 'Baiyin',
			'initial': 'B'
		},
		{
			'id': '652700',
			'name': '博尔塔拉蒙古自治州',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '博尔塔拉',
			'leveltype': 2,
			'citycode': '0909',
			'zipcode': '833400',
			'mergername': '中国,新疆维吾尔自治区,博尔塔拉蒙古自治州',
			'lng': '82.074778',
			'lat': '44.903258',
			'pinyin': 'Bortala',
			'initial': 'B'
		},
		{
			'id': '652800',
			'name': '巴音郭楞蒙古自治州',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '巴音郭楞',
			'leveltype': 2,
			'citycode': '0996',
			'zipcode': '841000',
			'mergername': '中国,新疆维吾尔自治区,巴音郭楞蒙古自治州',
			'lng': '86.150969',
			'lat': '41.768552',
			'pinyin': 'Bayingol',
			'initial': 'B'
		},
		{
			'id': '130800',
			'name': '承德市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '承德',
			'leveltype': 2,
			'citycode': '0314',
			'zipcode': '067000',
			'mergername': '中国,河北省,承德市',
			'lng': '117.939152',
			'lat': '40.976204',
			'pinyin': 'Chengde',
			'initial': 'C'
		},
		{
			'id': '130900',
			'name': '沧州市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '沧州',
			'leveltype': 2,
			'citycode': '0317',
			'zipcode': '061001',
			'mergername': '中国,河北省,沧州市',
			'lng': '116.857461',
			'lat': '38.310582',
			'pinyin': 'Cangzhou',
			'initial': 'C'
		},
		{
			'id': '140400',
			'name': '长治市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '长治',
			'leveltype': 2,
			'citycode': '0355',
			'zipcode': '046000',
			'mergername': '中国,山西省,长治市',
			'lng': '113.113556',
			'lat': '36.191112',
			'pinyin': 'Changzhi',
			'initial': 'C'
		},
		{
			'id': '150400',
			'name': '赤峰市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '赤峰',
			'leveltype': 2,
			'citycode': '0476',
			'zipcode': '024000',
			'mergername': '中国,内蒙古自治区,赤峰市',
			'lng': '118.956806',
			'lat': '42.275317',
			'pinyin': 'Chifeng',
			'initial': 'C'
		},
		{
			'id': '211300',
			'name': '朝阳市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '朝阳',
			'leveltype': 2,
			'citycode': '0421',
			'zipcode': '122000',
			'mergername': '中国,辽宁省,朝阳市',
			'lng': '120.451176',
			'lat': '41.576758',
			'pinyin': 'Chaoyang',
			'initial': 'C'
		},
		{
			'id': '220100',
			'name': '长春市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '长春',
			'leveltype': 2,
			'citycode': '0431',
			'zipcode': '130022',
			'mergername': '中国,吉林省,长春市',
			'lng': '125.3245',
			'lat': '43.886841',
			'pinyin': 'Changchun',
			'initial': 'C'
		},
		{
			'id': '320400',
			'name': '常州市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '常州',
			'leveltype': 2,
			'citycode': '0519',
			'zipcode': '213000',
			'mergername': '中国,江苏省,常州市',
			'lng': '119.946973',
			'lat': '31.772752',
			'pinyin': 'Changzhou',
			'initial': 'C'
		},
		{
			'id': '341100',
			'name': '滁州市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '滁州',
			'leveltype': 2,
			'citycode': '0550',
			'zipcode': '239000',
			'mergername': '中国,安徽省,滁州市',
			'lng': '118.316264',
			'lat': '32.303627',
			'pinyin': 'Chuzhou',
			'initial': 'C'
		},
		{
			'id': '341700',
			'name': '池州市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '池州',
			'leveltype': 2,
			'citycode': '0566',
			'zipcode': '247100',
			'mergername': '中国,安徽省,池州市',
			'lng': '117.489157',
			'lat': '30.656037',
			'pinyin': 'Chizhou',
			'initial': 'C'
		},
		{
			'id': '430100',
			'name': '长沙市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '长沙',
			'leveltype': 2,
			'citycode': '0731',
			'zipcode': '410005',
			'mergername': '中国,湖南省,长沙市',
			'lng': '112.982279',
			'lat': '28.19409',
			'pinyin': 'Changsha',
			'initial': 'C'
		},
		{
			'id': '430700',
			'name': '常德市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '常德',
			'leveltype': 2,
			'citycode': '0736',
			'zipcode': '415000',
			'mergername': '中国,湖南省,常德市',
			'lng': '111.691347',
			'lat': '29.040225',
			'pinyin': 'Changde',
			'initial': 'C'
		},
		{
			'id': '431000',
			'name': '郴州市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '郴州',
			'leveltype': 2,
			'citycode': '0735',
			'zipcode': '423000',
			'mergername': '中国,湖南省,郴州市',
			'lng': '113.032067',
			'lat': '25.793589',
			'pinyin': 'Chenzhou',
			'initial': 'C'
		},
		{
			'id': '445100',
			'name': '潮州市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '潮州',
			'leveltype': 2,
			'citycode': '0768',
			'zipcode': '521000',
			'mergername': '中国,广东省,潮州市',
			'lng': '116.632301',
			'lat': '23.661701',
			'pinyin': 'Chaozhou',
			'initial': 'C'
		},
		{
			'id': '451400',
			'name': '崇左市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '崇左',
			'leveltype': 2,
			'citycode': '0771',
			'zipcode': '532299',
			'mergername': '中国,广西壮族自治区,崇左市',
			'lng': '107.353926',
			'lat': '22.404108',
			'pinyin': 'Chongzuo',
			'initial': 'C'
		},
		{
			'id': '500100',
			'name': '重庆市',
			'areacode': null,
			'areaname': null,
			'pid': '500000',
			'shortname': '重庆',
			'leveltype': 2,
			'citycode': '023',
			'zipcode': '400000',
			'mergername': '中国,重庆,重庆市',
			'lng': '106.504962',
			'lat': '29.533155',
			'pinyin': 'Chongqing',
			'initial': 'C'
		},
		{
			'id': '500200',
			'name': '县',
			'areacode': null,
			'areaname': null,
			'pid': '500000',
			'shortname': '重庆',
			'leveltype': 2,
			'citycode': '023',
			'zipcode': '400000',
			'mergername': '中国,县,县市',
			'lng': '106.504962',
			'lat': '29.533155',
			'pinyin': 'xian',
			'initial': 'C'
		},
		{
			'id': '510100',
			'name': '成都市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '成都',
			'leveltype': 2,
			'citycode': '028',
			'zipcode': '610015',
			'mergername': '中国,四川省,成都市',
			'lng': '104.065735',
			'lat': '30.659462',
			'pinyin': 'Chengdu',
			'initial': 'C'
		},
		{
			'id': '532300',
			'name': '楚雄彝族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '楚雄',
			'leveltype': 2,
			'citycode': '0878',
			'zipcode': '675000',
			'mergername': '中国,云南省,楚雄彝族自治州',
			'lng': '101.546046',
			'lat': '25.041988',
			'pinyin': 'Chuxiong',
			'initial': 'C'
		},
		{
			'id': '652300',
			'name': '昌吉回族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '昌吉',
			'leveltype': 2,
			'citycode': '0994',
			'zipcode': '831100',
			'mergername': '中国,新疆维吾尔自治区,昌吉回族自治州',
			'lng': '87.304012',
			'lat': '44.014577',
			'pinyin': 'Changji',
			'initial': 'C'
		},
		{
			'id': '140200',
			'name': '大同市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '大同',
			'leveltype': 2,
			'citycode': '0352',
			'zipcode': '037008',
			'mergername': '中国,山西省,大同市',
			'lng': '113.295259',
			'lat': '40.09031',
			'pinyin': 'Datong',
			'initial': 'D'
		},
		{
			'id': '210200',
			'name': '大连市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '大连',
			'leveltype': 2,
			'citycode': '0411',
			'zipcode': '116011',
			'mergername': '中国,辽宁省,大连市',
			'lng': '121.618622',
			'lat': '38.91459',
			'pinyin': 'Dalian',
			'initial': 'D'
		},
		{
			'id': '210600',
			'name': '丹东市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '丹东',
			'leveltype': 2,
			'citycode': '0415',
			'zipcode': '118000',
			'mergername': '中国,辽宁省,丹东市',
			'lng': '124.383044',
			'lat': '40.124296',
			'pinyin': 'Dandong',
			'initial': 'D'
		},
		{
			'id': '230600',
			'name': '大庆市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '大庆',
			'leveltype': 2,
			'citycode': '0459',
			'zipcode': '163000',
			'mergername': '中国,黑龙江省,大庆市',
			'lng': '125.11272',
			'lat': '46.590734',
			'pinyin': 'Daqing',
			'initial': 'D'
		},
		{
			'id': '232700',
			'name': '大兴安岭地区',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '大兴安岭',
			'leveltype': 2,
			'citycode': '0457',
			'zipcode': '165000',
			'mergername': '中国,黑龙江省,大兴安岭地区',
			'lng': '124.711526',
			'lat': '52.335262',
			'pinyin': 'DaXingAnLing',
			'initial': 'D'
		},
		{
			'id': '370500',
			'name': '东营市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '东营',
			'leveltype': 2,
			'citycode': '0546',
			'zipcode': '257093',
			'mergername': '中国,山东省,东营市',
			'lng': '118.4963',
			'lat': '37.461266',
			'pinyin': 'Dongying',
			'initial': 'D'
		},
		{
			'id': '371400',
			'name': '德州市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '德州',
			'leveltype': 2,
			'citycode': '0534',
			'zipcode': '253000',
			'mergername': '中国,山东省,德州市',
			'lng': '116.307428',
			'lat': '37.453968',
			'pinyin': 'Dezhou',
			'initial': 'D'
		},
		{
			'id': '441900',
			'name': '东莞市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '东莞',
			'leveltype': 2,
			'citycode': '0769',
			'zipcode': '523888',
			'mergername': '中国,广东省,东莞市',
			'lng': '113.760234',
			'lat': '23.048884',
			'pinyin': 'Dongguan',
			'initial': 'D'
		},
		{
			'id': '510600',
			'name': '德阳市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '德阳',
			'leveltype': 2,
			'citycode': '0838',
			'zipcode': '618000',
			'mergername': '中国,四川省,德阳市',
			'lng': '104.398651',
			'lat': '31.127991',
			'pinyin': 'Deyang',
			'initial': 'D'
		},
		{
			'id': '511700',
			'name': '达州市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '达州',
			'leveltype': 2,
			'citycode': '0818',
			'zipcode': '635000',
			'mergername': '中国,四川省,达州市',
			'lng': '107.502262',
			'lat': '31.209484',
			'pinyin': 'Dazhou',
			'initial': 'D'
		},
		{
			'id': '532900',
			'name': '大理白族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '大理',
			'leveltype': 2,
			'citycode': '0872',
			'zipcode': '671000',
			'mergername': '中国,云南省,大理白族自治州',
			'lng': '100.240037',
			'lat': '25.592765',
			'pinyin': 'Dali',
			'initial': 'D'
		},
		{
			'id': '533100',
			'name': '德宏傣族景颇族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '德宏',
			'leveltype': 2,
			'citycode': '0692',
			'zipcode': '678400',
			'mergername': '中国,云南省,德宏傣族景颇族自治州',
			'lng': '98.578363',
			'lat': '24.436694',
			'pinyin': 'Dehong',
			'initial': 'D'
		},
		{
			'id': '533400',
			'name': '迪庆藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '迪庆',
			'leveltype': 2,
			'citycode': '0887',
			'zipcode': '674400',
			'mergername': '中国,云南省,迪庆藏族自治州',
			'lng': '99.706463',
			'lat': '27.826853',
			'pinyin': 'Deqen',
			'initial': 'D'
		},
		{
			'id': '621100',
			'name': '定西市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '定西',
			'leveltype': 2,
			'citycode': '0932',
			'zipcode': '743000',
			'mergername': '中国,甘肃省,定西市',
			'lng': '104.626294',
			'lat': '35.579578',
			'pinyin': 'Dingxi',
			'initial': 'D'
		},
		{
			'id': '420700',
			'name': '鄂州市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '鄂州',
			'leveltype': 2,
			'citycode': '0711',
			'zipcode': '436000',
			'mergername': '中国,湖北省,鄂州市',
			'lng': '114.890593',
			'lat': '30.396536',
			'pinyin': 'Ezhou',
			'initial': 'E'
		},
		{
			'id': '422800',
			'name': '恩施土家族苗族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '恩施',
			'leveltype': 2,
			'citycode': '0718',
			'zipcode': '445000',
			'mergername': '中国,湖北省,恩施土家族苗族自治州',
			'lng': '109.48699',
			'lat': '30.283114',
			'pinyin': 'Enshi',
			'initial': 'E'
		},
		{
			'id': '210400',
			'name': '抚顺市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '抚顺',
			'leveltype': 2,
			'citycode': '024',
			'zipcode': '113008',
			'mergername': '中国,辽宁省,抚顺市',
			'lng': '123.921109',
			'lat': '41.875956',
			'pinyin': 'Fushun',
			'initial': 'F'
		},
		{
			'id': '210900',
			'name': '阜新市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '阜新',
			'leveltype': 2,
			'citycode': '0418',
			'zipcode': '123000',
			'mergername': '中国,辽宁省,阜新市',
			'lng': '121.648962',
			'lat': '42.011796',
			'pinyin': 'Fuxin',
			'initial': 'F'
		},
		{
			'id': '341200',
			'name': '阜阳市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '阜阳',
			'leveltype': 2,
			'citycode': '0558',
			'zipcode': '236033',
			'mergername': '中国,安徽省,阜阳市',
			'lng': '115.819729',
			'lat': '32.896969',
			'pinyin': 'Fuyang',
			'initial': 'F'
		},
		{
			'id': '350100',
			'name': '福州市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '福州',
			'leveltype': 2,
			'citycode': '0591',
			'zipcode': '350001',
			'mergername': '中国,福建省,福州市',
			'lng': '119.306239',
			'lat': '26.075302',
			'pinyin': 'Fuzhou',
			'initial': 'F'
		},
		{
			'id': '361000',
			'name': '抚州市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '抚州',
			'leveltype': 2,
			'citycode': '0794',
			'zipcode': '344000',
			'mergername': '中国,江西省,抚州市',
			'lng': '116.358351',
			'lat': '27.98385',
			'pinyin': 'Fuzhou',
			'initial': 'F'
		},
		{
			'id': '440600',
			'name': '佛山市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '佛山',
			'leveltype': 2,
			'citycode': '0757',
			'zipcode': '528000',
			'mergername': '中国,广东省,佛山市',
			'lng': '113.122717',
			'lat': '23.028762',
			'pinyin': 'Foshan',
			'initial': 'F'
		},
		{
			'id': '450600',
			'name': '防城港市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '防城港',
			'leveltype': 2,
			'citycode': '0770',
			'zipcode': '538001',
			'mergername': '中国,广西壮族自治区,防城港市',
			'lng': '108.345478',
			'lat': '21.614631',
			'pinyin': 'Fangchenggang',
			'initial': 'F'
		},
		{
			'id': '360700',
			'name': '赣州市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '赣州',
			'leveltype': 2,
			'citycode': '0797',
			'zipcode': '341000',
			'mergername': '中国,江西省,赣州市',
			'lng': '114.940278',
			'lat': '25.85097',
			'pinyin': 'Ganzhou',
			'initial': 'G'
		},
		{
			'id': '440100',
			'name': '广州市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '广州',
			'leveltype': 2,
			'citycode': '020',
			'zipcode': '510032',
			'mergername': '中国,广东省,广州市',
			'lng': '113.280637',
			'lat': '23.125178',
			'pinyin': 'Guangzhou',
			'initial': 'G'
		},
		{
			'id': '450300',
			'name': '桂林市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '桂林',
			'leveltype': 2,
			'citycode': '0773',
			'zipcode': '541100',
			'mergername': '中国,广西壮族自治区,桂林市',
			'lng': '110.299121',
			'lat': '25.274215',
			'pinyin': 'Guilin',
			'initial': 'G'
		},
		{
			'id': '450800',
			'name': '贵港市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '贵港',
			'leveltype': 2,
			'citycode': '0775',
			'zipcode': '537100',
			'mergername': '中国,广西壮族自治区,贵港市',
			'lng': '109.602146',
			'lat': '23.0936',
			'pinyin': 'Guigang',
			'initial': 'G'
		},
		{
			'id': '510800',
			'name': '广元市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '广元',
			'leveltype': 2,
			'citycode': '0839',
			'zipcode': '628000',
			'mergername': '中国,四川省,广元市',
			'lng': '105.829757',
			'lat': '32.433668',
			'pinyin': 'Guangyuan',
			'initial': 'G'
		},
		{
			'id': '511600',
			'name': '广安市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '广安',
			'leveltype': 2,
			'citycode': '0826',
			'zipcode': '638000',
			'mergername': '中国,四川省,广安市',
			'lng': '106.633369',
			'lat': '30.456398',
			'pinyin': "Guang'an",
			'initial': 'G'
		},
		{
			'id': '513300',
			'name': '甘孜藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '甘孜',
			'leveltype': 2,
			'citycode': '0836',
			'zipcode': '626000',
			'mergername': '中国,四川省,甘孜藏族自治州',
			'lng': '101.963815',
			'lat': '30.050663',
			'pinyin': 'Garze',
			'initial': 'G'
		},
		{
			'id': '520100',
			'name': '贵阳市',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '贵阳',
			'leveltype': 2,
			'citycode': '0851',
			'zipcode': '550001',
			'mergername': '中国,贵州省,贵阳市',
			'lng': '106.713478',
			'lat': '26.578343',
			'pinyin': 'Guiyang',
			'initial': 'G'
		},
		{
			'id': '623000',
			'name': '甘南藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '甘南',
			'leveltype': 2,
			'citycode': '0941',
			'zipcode': '747000',
			'mergername': '中国,甘肃省,甘南藏族自治州',
			'lng': '102.911008',
			'lat': '34.986354',
			'pinyin': 'Gannan',
			'initial': 'G'
		},
		{
			'id': '632600',
			'name': '果洛藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '果洛',
			'leveltype': 2,
			'citycode': '0975',
			'zipcode': '814000',
			'mergername': '中国,青海省,果洛藏族自治州',
			'lng': '100.242143',
			'lat': '34.4736',
			'pinyin': 'Golog',
			'initial': 'G'
		},
		{
			'id': '640400',
			'name': '固原市',
			'areacode': null,
			'areaname': null,
			'pid': '640000',
			'shortname': '固原',
			'leveltype': 2,
			'citycode': '0954',
			'zipcode': '756000',
			'mergername': '中国,宁夏回族自治区,固原市',
			'lng': '106.285241',
			'lat': '36.004561',
			'pinyin': 'Guyuan',
			'initial': 'G'
		},
		{
			'id': '130400',
			'name': '邯郸市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '邯郸',
			'leveltype': 2,
			'citycode': '0310',
			'zipcode': '056002',
			'mergername': '中国,河北省,邯郸市',
			'lng': '114.490686',
			'lat': '36.612273',
			'pinyin': 'Handan',
			'initial': 'H'
		},
		{
			'id': '131100',
			'name': '衡水市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '衡水',
			'leveltype': 2,
			'citycode': '0318',
			'zipcode': '053000',
			'mergername': '中国,河北省,衡水市',
			'lng': '115.665993',
			'lat': '37.735097',
			'pinyin': 'Hengshui',
			'initial': 'H'
		},
		{
			'id': '150100',
			'name': '呼和浩特市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '呼和浩特',
			'leveltype': 2,
			'citycode': '0471',
			'zipcode': '010000',
			'mergername': '中国,内蒙古自治区,呼和浩特市',
			'lng': '111.670801',
			'lat': '40.818311',
			'pinyin': 'Hohhot',
			'initial': 'H'
		},
		{
			'id': '150700',
			'name': '呼伦贝尔市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '呼伦贝尔',
			'leveltype': 2,
			'citycode': '0470',
			'zipcode': '021008',
			'mergername': '中国,内蒙古自治区,呼伦贝尔市',
			'lng': '119.758168',
			'lat': '49.215333',
			'pinyin': 'Hulunber',
			'initial': 'H'
		},
		{
			'id': '152200',
			'name': '兴安盟',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '兴安盟',
			'leveltype': 2,
			'citycode': '0482',
			'zipcode': '137401',
			'mergername': '中国,内蒙古自治区,兴安盟',
			'lng': '122.070317',
			'lat': '46.076268',
			'pinyin': 'Hinggan',
			'initial': 'H'
		},
		{
			'id': '211400',
			'name': '葫芦岛市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '葫芦岛',
			'leveltype': 2,
			'citycode': '0429',
			'zipcode': '125000',
			'mergername': '中国,辽宁省,葫芦岛市',
			'lng': '120.856394',
			'lat': '40.755572',
			'pinyin': 'Huludao',
			'initial': 'H'
		},
		{
			'id': '230100',
			'name': '哈尔滨市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '哈尔滨',
			'leveltype': 2,
			'citycode': '0451',
			'zipcode': '150010',
			'mergername': '中国,黑龙江省,哈尔滨市',
			'lng': '126.642464',
			'lat': '45.756967',
			'pinyin': 'Harbin',
			'initial': 'H'
		},
		{
			'id': '230400',
			'name': '鹤岗市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '鹤岗',
			'leveltype': 2,
			'citycode': '0468',
			'zipcode': '154100',
			'mergername': '中国,黑龙江省,鹤岗市',
			'lng': '130.277487',
			'lat': '47.332085',
			'pinyin': 'Hegang',
			'initial': 'H'
		},
		{
			'id': '231100',
			'name': '黑河市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '黑河',
			'leveltype': 2,
			'citycode': '0456',
			'zipcode': '164300',
			'mergername': '中国,黑龙江省,黑河市',
			'lng': '127.499023',
			'lat': '50.249585',
			'pinyin': 'Heihe',
			'initial': 'H'
		},
		{
			'id': '320800',
			'name': '淮安市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '淮安',
			'leveltype': 2,
			'citycode': '0517',
			'zipcode': '223001',
			'mergername': '中国,江苏省,淮安市',
			'lng': '119.021265',
			'lat': '33.597506',
			'pinyin': "Huai'an",
			'initial': 'H'
		},
		{
			'id': '330100',
			'name': '杭州市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '杭州',
			'leveltype': 2,
			'citycode': '0571',
			'zipcode': '310026',
			'mergername': '中国,浙江省,杭州市',
			'lng': '120.153576',
			'lat': '30.287459',
			'pinyin': 'Hangzhou',
			'initial': 'H'
		},
		{
			'id': '330500',
			'name': '湖州市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '湖州',
			'leveltype': 2,
			'citycode': '0572',
			'zipcode': '313000',
			'mergername': '中国,浙江省,湖州市',
			'lng': '120.102398',
			'lat': '30.867198',
			'pinyin': 'Huzhou',
			'initial': 'H'
		},
		{
			'id': '340100',
			'name': '合肥市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '合肥',
			'leveltype': 2,
			'citycode': '0551',
			'zipcode': '230001',
			'mergername': '中国,安徽省,合肥市',
			'lng': '117.283042',
			'lat': '31.86119',
			'pinyin': 'Hefei',
			'initial': 'H'
		},
		{
			'id': '340400',
			'name': '淮南市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '淮南',
			'leveltype': 2,
			'citycode': '0554',
			'zipcode': '232001',
			'mergername': '中国,安徽省,淮南市',
			'lng': '117.025449',
			'lat': '32.645947',
			'pinyin': 'Huainan',
			'initial': 'H'
		},
		{
			'id': '340600',
			'name': '淮北市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '淮北',
			'leveltype': 2,
			'citycode': '0561',
			'zipcode': '235000',
			'mergername': '中国,安徽省,淮北市',
			'lng': '116.794664',
			'lat': '33.971707',
			'pinyin': 'Huaibei',
			'initial': 'H'
		},
		{
			'id': '341000',
			'name': '黄山市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '黄山',
			'leveltype': 2,
			'citycode': '0559',
			'zipcode': '245000',
			'mergername': '中国,安徽省,黄山市',
			'lng': '118.317325',
			'lat': '29.709239',
			'pinyin': 'Huangshan',
			'initial': 'H'
		},
		{
			'id': '371700',
			'name': '菏泽市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '菏泽',
			'leveltype': 2,
			'citycode': '0530',
			'zipcode': '274020',
			'mergername': '中国,山东省,菏泽市',
			'lng': '115.469381',
			'lat': '35.246531',
			'pinyin': 'Heze',
			'initial': 'H'
		},
		{
			'id': '410600',
			'name': '鹤壁市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '鹤壁',
			'leveltype': 2,
			'citycode': '0392',
			'zipcode': '458030',
			'mergername': '中国,河南省,鹤壁市',
			'lng': '114.295444',
			'lat': '35.748236',
			'pinyin': 'Hebi',
			'initial': 'H'
		},
		{
			'id': '420200',
			'name': '黄石市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '黄石',
			'leveltype': 2,
			'citycode': '0714',
			'zipcode': '435003',
			'mergername': '中国,湖北省,黄石市',
			'lng': '115.077048',
			'lat': '30.220074',
			'pinyin': 'Huangshi',
			'initial': 'H'
		},
		{
			'id': '421100',
			'name': '黄冈市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '黄冈',
			'leveltype': 2,
			'citycode': '0713',
			'zipcode': '438000',
			'mergername': '中国,湖北省,黄冈市',
			'lng': '114.879365',
			'lat': '30.447711',
			'pinyin': 'Huanggang',
			'initial': 'H'
		},
		{
			'id': '430400',
			'name': '衡阳市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '衡阳',
			'leveltype': 2,
			'citycode': '0734',
			'zipcode': '421001',
			'mergername': '中国,湖南省,衡阳市',
			'lng': '112.607693',
			'lat': '26.900358',
			'pinyin': 'Hengyang',
			'initial': 'H'
		},
		{
			'id': '431200',
			'name': '怀化市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '怀化',
			'leveltype': 2,
			'citycode': '0745',
			'zipcode': '418000',
			'mergername': '中国,湖南省,怀化市',
			'lng': '109.97824',
			'lat': '27.550082',
			'pinyin': 'Huaihua',
			'initial': 'H'
		},
		{
			'id': '441300',
			'name': '惠州市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '惠州',
			'leveltype': 2,
			'citycode': '0752',
			'zipcode': '516000',
			'mergername': '中国,广东省,惠州市',
			'lng': '114.412599',
			'lat': '23.079404',
			'pinyin': 'Huizhou',
			'initial': 'H'
		},
		{
			'id': '441600',
			'name': '河源市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '河源',
			'leveltype': 2,
			'citycode': '0762',
			'zipcode': '517000',
			'mergername': '中国,广东省,河源市',
			'lng': '114.697802',
			'lat': '23.746266',
			'pinyin': 'Heyuan',
			'initial': 'H'
		},
		{
			'id': '451100',
			'name': '贺州市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '贺州',
			'leveltype': 2,
			'citycode': '0774',
			'zipcode': '542800',
			'mergername': '中国,广西壮族自治区,贺州市',
			'lng': '111.552056',
			'lat': '24.414141',
			'pinyin': 'Hezhou',
			'initial': 'H'
		},
		{
			'id': '451200',
			'name': '河池市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '河池',
			'leveltype': 2,
			'citycode': '0778',
			'zipcode': '547000',
			'mergername': '中国,广西壮族自治区,河池市',
			'lng': '108.062105',
			'lat': '24.695899',
			'pinyin': 'Hechi',
			'initial': 'H'
		},
		{
			'id': '460100',
			'name': '海口市',
			'areacode': null,
			'areaname': null,
			'pid': '460000',
			'shortname': '海口',
			'leveltype': 2,
			'citycode': '0898',
			'zipcode': '570000',
			'mergername': '中国,海南省,海口市',
			'lng': '110.33119',
			'lat': '20.031971',
			'pinyin': 'Haikou',
			'initial': 'H'
		},
		{
			'id': '532500',
			'name': '红河哈尼族彝族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '红河',
			'leveltype': 2,
			'citycode': '0873',
			'zipcode': '661400',
			'mergername': '中国,云南省,红河哈尼族彝族自治州',
			'lng': '103.384182',
			'lat': '23.366775',
			'pinyin': 'Honghe',
			'initial': 'H'
		},
		{
			'id': '610700',
			'name': '汉中市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '汉中',
			'leveltype': 2,
			'citycode': '0916',
			'zipcode': '723000',
			'mergername': '中国,陕西省,汉中市',
			'lng': '107.028621',
			'lat': '33.077668',
			'pinyin': 'Hanzhong',
			'initial': 'H'
		},
		{
			'id': '630200',
			'name': '海东市',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '海东',
			'leveltype': 2,
			'citycode': '0972',
			'zipcode': '810700',
			'mergername': '中国,青海省,海东市',
			'lng': '102.10327',
			'lat': '36.502916',
			'pinyin': 'Haidong',
			'initial': 'H'
		},
		{
			'id': '632200',
			'name': '海北藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '海北',
			'leveltype': 2,
			'citycode': '0970',
			'zipcode': '812200',
			'mergername': '中国,青海省,海北藏族自治州',
			'lng': '100.901059',
			'lat': '36.959435',
			'pinyin': 'Haibei',
			'initial': 'H'
		},
		{
			'id': '632300',
			'name': '黄南藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '黄南',
			'leveltype': 2,
			'citycode': '0973',
			'zipcode': '811300',
			'mergername': '中国,青海省,黄南藏族自治州',
			'lng': '102.019988',
			'lat': '35.517744',
			'pinyin': 'Huangnan',
			'initial': 'H'
		},
		{
			'id': '632500',
			'name': '海南藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '海南',
			'leveltype': 2,
			'citycode': '0974',
			'zipcode': '813000',
			'mergername': '中国,青海省,海南藏族自治州',
			'lng': '100.619542',
			'lat': '36.280353',
			'pinyin': 'Hainan',
			'initial': 'H'
		},
		{
			'id': '632800',
			'name': '海西蒙古族藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '海西',
			'leveltype': 2,
			'citycode': '0977',
			'zipcode': '817000',
			'mergername': '中国,青海省,海西蒙古族藏族自治州',
			'lng': '97.370785',
			'lat': '37.374663',
			'pinyin': 'Haixi',
			'initial': 'H'
		},
		// {
		// 	'id': '652200',
		// 	'name': '哈密地区',
		// 	'areacode': null,
		// 	'areaname': null,
		// 	'pid': '650000',
		// 	'shortname': '哈密',
		// 	'leveltype': 2,
		// 	'citycode': '0902',
		// 	'zipcode': '839000',
		// 	'mergername': '中国,新疆维吾尔自治区,哈密地区',
		// 	'lng': '93.51316',
		// 	'lat': '42.833248',
		// 	'pinyin': 'Hami',
		// 	'initial': 'H'
		// },
		{
			'id': '650500',
			'name': '哈密市',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '哈密',
			'leveltype': 2,
			'citycode': '0902',
			'zipcode': '839000',
			'mergername': '中国,新疆维吾尔自治区,哈密市',
			'lng': '93.51316',
			'lat': '42.833248',
			'pinyin': 'Hami',
			'initial': 'H'
		},
		{
			'id': '653200',
			'name': '和田地区',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '和田',
			'leveltype': 2,
			'citycode': '0903',
			'zipcode': '848000',
			'mergername': '中国,新疆维吾尔自治区,和田地区',
			'lng': '79.92533',
			'lat': '37.110687',
			'pinyin': 'Hotan',
			'initial': 'H'
		},
		{
			'id': '654000',
			'name': '伊犁哈萨克自治州',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '伊犁',
			'leveltype': 2,
			'citycode': '0999',
			'zipcode': '835100',
			'mergername': '中国,新疆维吾尔自治区,伊犁哈萨克自治州',
			'lng': '81.317946',
			'lat': '43.92186',
			'pinyin': 'Ili',
			'initial': 'I'
		},
		{
			'id': '140500',
			'name': '晋城市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '晋城',
			'leveltype': 2,
			'citycode': '0356',
			'zipcode': '048000',
			'mergername': '中国,山西省,晋城市',
			'lng': '112.851274',
			'lat': '35.497553',
			'pinyin': 'Jincheng',
			'initial': 'J'
		},
		{
			'id': '140700',
			'name': '晋中市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '晋中',
			'leveltype': 2,
			'citycode': '0354',
			'zipcode': '030600',
			'mergername': '中国,山西省,晋中市',
			'lng': '112.736465',
			'lat': '37.696495',
			'pinyin': 'Jinzhong',
			'initial': 'J'
		},
		{
			'id': '210700',
			'name': '锦州市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '锦州',
			'leveltype': 2,
			'citycode': '0416',
			'zipcode': '121000',
			'mergername': '中国,辽宁省,锦州市',
			'lng': '121.135742',
			'lat': '41.119269',
			'pinyin': 'Jinzhou',
			'initial': 'J'
		},
		{
			'id': '211500',
			'name': '金普新区',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '金普新区',
			'leveltype': 2,
			'citycode': '0411',
			'zipcode': '116100',
			'mergername': '中国,辽宁省,金普新区',
			'lng': '121.789627',
			'lat': '39.055451',
			'pinyin': 'Jinpuxinqu',
			'initial': 'J'
		},
		{
			'id': '220200',
			'name': '吉林市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '吉林',
			'leveltype': 2,
			'citycode': '0432',
			'zipcode': '132011',
			'mergername': '中国,吉林省,吉林市',
			'lng': '126.55302',
			'lat': '43.843577',
			'pinyin': 'Jilin',
			'initial': 'J'
		},
		{
			'id': '230300',
			'name': '鸡西市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '鸡西',
			'leveltype': 2,
			'citycode': '0467',
			'zipcode': '158100',
			'mergername': '中国,黑龙江省,鸡西市',
			'lng': '130.975966',
			'lat': '45.300046',
			'pinyin': 'Jixi',
			'initial': 'J'
		},
		{
			'id': '230800',
			'name': '佳木斯市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '佳木斯',
			'leveltype': 2,
			'citycode': '0454',
			'zipcode': '154002',
			'mergername': '中国,黑龙江省,佳木斯市',
			'lng': '130.361634',
			'lat': '46.809606',
			'pinyin': 'Jiamusi',
			'initial': 'J'
		},
		{
			'id': '330400',
			'name': '嘉兴市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '嘉兴',
			'leveltype': 2,
			'citycode': '0573',
			'zipcode': '314000',
			'mergername': '中国,浙江省,嘉兴市',
			'lng': '120.750865',
			'lat': '30.762653',
			'pinyin': 'Jiaxing',
			'initial': 'J'
		},
		{
			'id': '330700',
			'name': '金华市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '金华',
			'leveltype': 2,
			'citycode': '0579',
			'zipcode': '321000',
			'mergername': '中国,浙江省,金华市',
			'lng': '119.649506',
			'lat': '29.089524',
			'pinyin': 'Jinhua',
			'initial': 'J'
		},
		{
			'id': '360200',
			'name': '景德镇市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '景德镇',
			'leveltype': 2,
			'citycode': '0798',
			'zipcode': '333000',
			'mergername': '中国,江西省,景德镇市',
			'lng': '117.214664',
			'lat': '29.29256',
			'pinyin': 'Jingdezhen',
			'initial': 'J'
		},
		{
			'id': '360400',
			'name': '九江市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '九江',
			'leveltype': 2,
			'citycode': '0792',
			'zipcode': '332000',
			'mergername': '中国,江西省,九江市',
			'lng': '115.992811',
			'lat': '29.712034',
			'pinyin': 'Jiujiang',
			'initial': 'J'
		},
		{
			'id': '360800',
			'name': '吉安市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '吉安',
			'leveltype': 2,
			'citycode': '0796',
			'zipcode': '343000',
			'mergername': '中国,江西省,吉安市',
			'lng': '114.986373',
			'lat': '27.111699',
			'pinyin': "Ji'an",
			'initial': 'J'
		},
		{
			'id': '370100',
			'name': '济南市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '济南',
			'leveltype': 2,
			'citycode': '0531',
			'zipcode': '250001',
			'mergername': '中国,山东省,济南市',
			'lng': '117.000923',
			'lat': '36.675807',
			'pinyin': 'Jinan',
			'initial': 'J'
		},
		{
			'id': '370800',
			'name': '济宁市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '济宁',
			'leveltype': 2,
			'citycode': '0537',
			'zipcode': '272119',
			'mergername': '中国,山东省,济宁市',
			'lng': '116.587245',
			'lat': '35.415393',
			'pinyin': 'Jining',
			'initial': 'J'
		},
		{
			'id': '410800',
			'name': '焦作市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '焦作',
			'leveltype': 2,
			'citycode': '0391',
			'zipcode': '454002',
			'mergername': '中国,河南省,焦作市',
			'lng': '113.238266',
			'lat': '35.23904',
			'pinyin': 'Jiaozuo',
			'initial': 'J'
		},
		{
			'id': '420800',
			'name': '荆门市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '荆门',
			'leveltype': 2,
			'citycode': '0724',
			'zipcode': '448000',
			'mergername': '中国,湖北省,荆门市',
			'lng': '112.204251',
			'lat': '31.03542',
			'pinyin': 'Jingmen',
			'initial': 'J'
		},
		{
			'id': '421000',
			'name': '荆州市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '荆州',
			'leveltype': 2,
			'citycode': '0716',
			'zipcode': '434000',
			'mergername': '中国,湖北省,荆州市',
			'lng': '112.23813',
			'lat': '30.326857',
			'pinyin': 'Jingzhou',
			'initial': 'J'
		},
		{
			'id': '440700',
			'name': '江门市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '江门',
			'leveltype': 2,
			'citycode': '0750',
			'zipcode': '529000',
			'mergername': '中国,广东省,江门市',
			'lng': '113.094942',
			'lat': '22.590431',
			'pinyin': 'Jiangmen',
			'initial': 'J'
		},
		{
			'id': '445200',
			'name': '揭阳市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '揭阳',
			'leveltype': 2,
			'citycode': '0633',
			'zipcode': '522000',
			'mergername': '中国,广东省,揭阳市',
			'lng': '116.355733',
			'lat': '23.543778',
			'pinyin': 'Jieyang',
			'initial': 'J'
		},
		{
			'id': '620200',
			'name': '嘉峪关市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '嘉峪关',
			'leveltype': 2,
			'citycode': '0937',
			'zipcode': '735100',
			'mergername': '中国,甘肃省,嘉峪关市',
			'lng': '98.277304',
			'lat': '39.786529',
			'pinyin': 'Jiayuguan',
			'initial': 'J'
		},
		{
			'id': '620300',
			'name': '金昌市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '金昌',
			'leveltype': 2,
			'citycode': '0935',
			'zipcode': '737100',
			'mergername': '中国,甘肃省,金昌市',
			'lng': '102.187888',
			'lat': '38.514238',
			'pinyin': 'Jinchang',
			'initial': 'J'
		},
		{
			'id': '620900',
			'name': '酒泉市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '酒泉',
			'leveltype': 2,
			'citycode': '0937',
			'zipcode': '735000',
			'mergername': '中国,甘肃省,酒泉市',
			'lng': '98.510795',
			'lat': '39.744023',
			'pinyin': 'Jiuquan',
			'initial': 'J'
		},
		{
			'id': '410200',
			'name': '开封市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '开封',
			'leveltype': 2,
			'citycode': '0378',
			'zipcode': '475001',
			'mergername': '中国,河南省,开封市',
			'lng': '114.341447',
			'lat': '34.797049',
			'pinyin': 'Kaifeng',
			'initial': 'K'
		},
		{
			'id': '530100',
			'name': '昆明市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '昆明',
			'leveltype': 2,
			'citycode': '0871',
			'zipcode': '650500',
			'mergername': '中国,云南省,昆明市',
			'lng': '102.712251',
			'lat': '25.040609',
			'pinyin': 'Kunming',
			'initial': 'K'
		},
		{
			'id': '650200',
			'name': '克拉玛依市',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '克拉玛依',
			'leveltype': 2,
			'citycode': '0990',
			'zipcode': '834000',
			'mergername': '中国,新疆维吾尔自治区,克拉玛依市',
			'lng': '84.873946',
			'lat': '45.595886',
			'pinyin': 'Karamay',
			'initial': 'K'
		},
		{
			'id': '653000',
			'name': '克孜勒苏柯尔克孜自治州',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '克孜勒苏',
			'leveltype': 2,
			'citycode': '0908',
			'zipcode': '845350',
			'mergername': '中国,新疆维吾尔自治区,克孜勒苏柯尔克孜自治州',
			'lng': '76.172825',
			'lat': '39.713431',
			'pinyin': 'Kizilsu',
			'initial': 'K'
		},
		{
			'id': '653100',
			'name': '喀什地区',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '喀什',
			'leveltype': 2,
			'citycode': '0998',
			'zipcode': '844000',
			'mergername': '中国,新疆维吾尔自治区,喀什地区',
			'lng': '75.989138',
			'lat': '39.467664',
			'pinyin': 'Kashgar',
			'initial': 'K'
		},
		{
			'id': '131000',
			'name': '廊坊市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '廊坊',
			'leveltype': 2,
			'citycode': '0316',
			'zipcode': '065000',
			'mergername': '中国,河北省,廊坊市',
			'lng': '116.713873',
			'lat': '39.529244',
			'pinyin': 'Langfang',
			'initial': 'L'
		},
		{
			'id': '141000',
			'name': '临汾市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '临汾',
			'leveltype': 2,
			'citycode': '0357',
			'zipcode': '041000',
			'mergername': '中国,山西省,临汾市',
			'lng': '111.517973',
			'lat': '36.08415',
			'pinyin': 'Linfen',
			'initial': 'L'
		},
		{
			'id': '141100',
			'name': '吕梁市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '吕梁',
			'leveltype': 2,
			'citycode': '0358',
			'zipcode': '033000',
			'mergername': '中国,山西省,吕梁市',
			'lng': '111.134335',
			'lat': '37.524366',
			'pinyin': 'Lvliang',
			'initial': 'L'
		},
		{
			'id': '211000',
			'name': '辽阳市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '辽阳',
			'leveltype': 2,
			'citycode': '0419',
			'zipcode': '111000',
			'mergername': '中国,辽宁省,辽阳市',
			'lng': '123.18152',
			'lat': '41.269402',
			'pinyin': 'Liaoyang',
			'initial': 'L'
		},
		{
			'id': '220400',
			'name': '辽源市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '辽源',
			'leveltype': 2,
			'citycode': '0437',
			'zipcode': '136200',
			'mergername': '中国,吉林省,辽源市',
			'lng': '125.145349',
			'lat': '42.902692',
			'pinyin': 'Liaoyuan',
			'initial': 'L'
		},
		{
			'id': '320700',
			'name': '连云港市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '连云港',
			'leveltype': 2,
			'citycode': '0518',
			'zipcode': '222002',
			'mergername': '中国,江苏省,连云港市',
			'lng': '119.178821',
			'lat': '34.600018',
			'pinyin': 'Lianyungang',
			'initial': 'L'
		},
		{
			'id': '331100',
			'name': '丽水市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '丽水',
			'leveltype': 2,
			'citycode': '0578',
			'zipcode': '323000',
			'mergername': '中国,浙江省,丽水市',
			'lng': '119.921786',
			'lat': '28.451993',
			'pinyin': 'Lishui',
			'initial': 'L'
		},
		{
			'id': '341500',
			'name': '六安市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '六安',
			'leveltype': 2,
			'citycode': '0564',
			'zipcode': '237000',
			'mergername': '中国,安徽省,六安市',
			'lng': '116.507676',
			'lat': '31.752889',
			'pinyin': "Lu'an",
			'initial': 'L'
		},
		{
			'id': '350800',
			'name': '龙岩市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '龙岩',
			'leveltype': 2,
			'citycode': '0597',
			'zipcode': '364000',
			'mergername': '中国,福建省,龙岩市',
			'lng': '117.02978',
			'lat': '25.091603',
			'pinyin': 'Longyan',
			'initial': 'L'
		},
		{
			'id': '371200',
			'name': '莱芜市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '莱芜',
			'leveltype': 2,
			'citycode': '0634',
			'zipcode': '271100',
			'mergername': '中国,山东省,莱芜市',
			'lng': '117.677736',
			'lat': '36.214397',
			'pinyin': 'Laiwu',
			'initial': 'L'
		},
		{
			'id': '371300',
			'name': '临沂市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '临沂',
			'leveltype': 2,
			'citycode': '0539',
			'zipcode': '253000',
			'mergername': '中国,山东省,临沂市',
			'lng': '118.326443',
			'lat': '35.065282',
			'pinyin': 'Linyi',
			'initial': 'L'
		},
		{
			'id': '371500',
			'name': '聊城市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '聊城',
			'leveltype': 2,
			'citycode': '0635',
			'zipcode': '252052',
			'mergername': '中国,山东省,聊城市',
			'lng': '115.980367',
			'lat': '36.456013',
			'pinyin': 'Liaocheng',
			'initial': 'L'
		},
		{
			'id': '410300',
			'name': '洛阳市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '洛阳',
			'leveltype': 2,
			'citycode': '0379',
			'zipcode': '471000',
			'mergername': '中国,河南省,洛阳市',
			'lng': '112.434468',
			'lat': '34.663041',
			'pinyin': 'Luoyang',
			'initial': 'L'
		},
		{
			'id': '411100',
			'name': '漯河市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '漯河',
			'leveltype': 2,
			'citycode': '0395',
			'zipcode': '462000',
			'mergername': '中国,河南省,漯河市',
			'lng': '114.026405',
			'lat': '33.575855',
			'pinyin': 'Luohe',
			'initial': 'L'
		},
		{
			'id': '431300',
			'name': '娄底市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '娄底',
			'leveltype': 2,
			'citycode': '0738',
			'zipcode': '417000',
			'mergername': '中国,湖南省,娄底市',
			'lng': '112.008497',
			'lat': '27.728136',
			'pinyin': 'Loudi',
			'initial': 'L'
		},
		{
			'id': '450200',
			'name': '柳州市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '柳州',
			'leveltype': 2,
			'citycode': '0772',
			'zipcode': '545001',
			'mergername': '中国,广西壮族自治区,柳州市',
			'lng': '109.411703',
			'lat': '24.314617',
			'pinyin': 'Liuzhou',
			'initial': 'L'
		},
		{
			'id': '451300',
			'name': '来宾市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '来宾',
			'leveltype': 2,
			'citycode': '0772',
			'zipcode': '546100',
			'mergername': '中国,广西壮族自治区,来宾市',
			'lng': '109.229772',
			'lat': '23.733766',
			'pinyin': 'Laibin',
			'initial': 'L'
		},
		{
			'id': '500300',
			'name': '两江新区',
			'areacode': null,
			'areaname': null,
			'pid': '500000',
			'shortname': '两江新区',
			'leveltype': 2,
			'citycode': '023',
			'zipcode': '400000',
			'mergername': '中国,重庆,两江新区',
			'lng': '106.463344',
			'lat': '29.729153',
			'pinyin': 'Liangjiangxinqu',
			'initial': 'L'
		},
		{
			'id': '510500',
			'name': '泸州市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '泸州',
			'leveltype': 2,
			'citycode': '0830',
			'zipcode': '646000',
			'mergername': '中国,四川省,泸州市',
			'lng': '105.443348',
			'lat': '28.889138',
			'pinyin': 'Luzhou',
			'initial': 'L'
		},
		{
			'id': '511100',
			'name': '乐山市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '乐山',
			'leveltype': 2,
			'citycode': '0833',
			'zipcode': '614000',
			'mergername': '中国,四川省,乐山市',
			'lng': '103.761263',
			'lat': '29.582024',
			'pinyin': 'Leshan',
			'initial': 'L'
		},
		{
			'id': '513400',
			'name': '凉山彝族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '凉山',
			'leveltype': 2,
			'citycode': '0834',
			'zipcode': '615000',
			'mergername': '中国,四川省,凉山彝族自治州',
			'lng': '102.258746',
			'lat': '27.886762',
			'pinyin': 'Liangshan',
			'initial': 'L'
		},
		{
			'id': '520200',
			'name': '六盘水市',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '六盘水',
			'leveltype': 2,
			'citycode': '0858',
			'zipcode': '553400',
			'mergername': '中国,贵州省,六盘水市',
			'lng': '104.846743',
			'lat': '26.584643',
			'pinyin': 'Liupanshui',
			'initial': 'L'
		},
		{
			'id': '530700',
			'name': '丽江市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '丽江',
			'leveltype': 2,
			'citycode': '0888',
			'zipcode': '674100',
			'mergername': '中国,云南省,丽江市',
			'lng': '100.233026',
			'lat': '26.872108',
			'pinyin': 'Lijiang',
			'initial': 'L'
		},
		{
			'id': '530900',
			'name': '临沧市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '临沧',
			'leveltype': 2,
			'citycode': '0883',
			'zipcode': '677000',
			'mergername': '中国,云南省,临沧市',
			'lng': '100.08697',
			'lat': '23.886567',
			'pinyin': 'Lincang',
			'initial': 'L'
		},
		{
			'id': '540100',
			'name': '拉萨市',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '拉萨',
			'leveltype': 2,
			'citycode': '0891',
			'zipcode': '850000',
			'mergername': '中国,西藏自治区,拉萨市',
			'lng': '91.132212',
			'lat': '29.660361',
			'pinyin': 'Lhasa',
			'initial': 'L'
		},
		{
			'id': '620100',
			'name': '兰州市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '兰州',
			'leveltype': 2,
			'citycode': '0931',
			'zipcode': '730030',
			'mergername': '中国,甘肃省,兰州市',
			'lng': '103.823557',
			'lat': '36.058039',
			'pinyin': 'Lanzhou',
			'initial': 'L'
		},
		{
			'id': '621200',
			'name': '陇南市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '陇南',
			'leveltype': 2,
			'citycode': '0939',
			'zipcode': '746000',
			'mergername': '中国,甘肃省,陇南市',
			'lng': '104.929379',
			'lat': '33.388598',
			'pinyin': 'Longnan',
			'initial': 'L'
		},
		{
			'id': '622900',
			'name': '临夏回族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '临夏',
			'leveltype': 2,
			'citycode': '0930',
			'zipcode': '731100',
			'mergername': '中国,甘肃省,临夏回族自治州',
			'lng': '103.212006',
			'lat': '35.599446',
			'pinyin': 'Linxia',
			'initial': 'L'
		},
		{
			'id': '231000',
			'name': '牡丹江市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '牡丹江',
			'leveltype': 2,
			'citycode': '0453',
			'zipcode': '157000',
			'mergername': '中国,黑龙江省,牡丹江市',
			'lng': '129.618602',
			'lat': '44.582962',
			'pinyin': 'Mudanjiang',
			'initial': 'M'
		},
		{
			'id': '340500',
			'name': '马鞍山市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '马鞍山',
			'leveltype': 2,
			'citycode': '0555',
			'zipcode': '243001',
			'mergername': '中国,安徽省,马鞍山市',
			'lng': '118.507906',
			'lat': '31.689362',
			'pinyin': "Ma'anshan",
			'initial': 'M'
		},
		{
			'id': '440900',
			'name': '茂名市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '茂名',
			'leveltype': 2,
			'citycode': '0668',
			'zipcode': '525000',
			'mergername': '中国,广东省,茂名市',
			'lng': '110.919229',
			'lat': '21.659751',
			'pinyin': 'Maoming',
			'initial': 'M'
		},
		{
			'id': '441400',
			'name': '梅州市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '梅州',
			'leveltype': 2,
			'citycode': '0753',
			'zipcode': '514021',
			'mergername': '中国,广东省,梅州市',
			'lng': '116.117582',
			'lat': '24.299112',
			'pinyin': 'Meizhou',
			'initial': 'M'
		},
		{
			'id': '510700',
			'name': '绵阳市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '绵阳',
			'leveltype': 2,
			'citycode': '0816',
			'zipcode': '621000',
			'mergername': '中国,四川省,绵阳市',
			'lng': '104.741722',
			'lat': '31.46402',
			'pinyin': 'Mianyang',
			'initial': 'M'
		},
		{
			'id': '511400',
			'name': '眉山市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '眉山',
			'leveltype': 2,
			'citycode': '028',
			'zipcode': '620020',
			'mergername': '中国,四川省,眉山市',
			'lng': '103.831788',
			'lat': '30.048318',
			'pinyin': 'Meishan',
			'initial': 'M'
		},
		{
			'id': '320100',
			'name': '南京市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '南京',
			'leveltype': 2,
			'citycode': '025',
			'zipcode': '210008',
			'mergername': '中国,江苏省,南京市',
			'lng': '118.767413',
			'lat': '32.041544',
			'pinyin': 'Nanjing',
			'initial': 'N'
		},
		{
			'id': '320600',
			'name': '南通市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '南通',
			'leveltype': 2,
			'citycode': '0513',
			'zipcode': '226001',
			'mergername': '中国,江苏省,南通市',
			'lng': '120.864608',
			'lat': '32.016212',
			'pinyin': 'Nantong',
			'initial': 'N'
		},
		{
			'id': '330200',
			'name': '宁波市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '宁波',
			'leveltype': 2,
			'citycode': '0574',
			'zipcode': '315000',
			'mergername': '中国,浙江省,宁波市',
			'lng': '121.549792',
			'lat': '29.868388',
			'pinyin': 'Ningbo',
			'initial': 'N'
		},
		{
			'id': '350700',
			'name': '南平市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '南平',
			'leveltype': 2,
			'citycode': '0599',
			'zipcode': '353000',
			'mergername': '中国,福建省,南平市',
			'lng': '118.178459',
			'lat': '26.635627',
			'pinyin': 'Nanping',
			'initial': 'N'
		},
		{
			'id': '350900',
			'name': '宁德市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '宁德',
			'leveltype': 2,
			'citycode': '0593',
			'zipcode': '352100',
			'mergername': '中国,福建省,宁德市',
			'lng': '119.527082',
			'lat': '26.65924',
			'pinyin': 'Ningde',
			'initial': 'N'
		},
		{
			'id': '360100',
			'name': '南昌市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '南昌',
			'leveltype': 2,
			'citycode': '0791',
			'zipcode': '330008',
			'mergername': '中国,江西省,南昌市',
			'lng': '115.892151',
			'lat': '28.676493',
			'pinyin': 'Nanchang',
			'initial': 'N'
		},
		{
			'id': '411300',
			'name': '南阳市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '南阳',
			'leveltype': 2,
			'citycode': '0377',
			'zipcode': '473002',
			'mergername': '中国,河南省,南阳市',
			'lng': '112.540918',
			'lat': '32.999082',
			'pinyin': 'Nanyang',
			'initial': 'N'
		},
		{
			'id': '450100',
			'name': '南宁市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '南宁',
			'leveltype': 2,
			'citycode': '0771',
			'zipcode': '530028',
			'mergername': '中国,广西壮族自治区,南宁市',
			'lng': '108.320004',
			'lat': '22.82402',
			'pinyin': 'Nanning',
			'initial': 'N'
		},
		{
			'id': '511000',
			'name': '内江市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '内江',
			'leveltype': 2,
			'citycode': '0832',
			'zipcode': '641000',
			'mergername': '中国,四川省,内江市',
			'lng': '105.066138',
			'lat': '29.58708',
			'pinyin': 'Neijiang',
			'initial': 'N'
		},
		{
			'id': '511300',
			'name': '南充市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '南充',
			'leveltype': 2,
			'citycode': '0817',
			'zipcode': '637000',
			'mergername': '中国,四川省,南充市',
			'lng': '106.082974',
			'lat': '30.795281',
			'pinyin': 'Nanchong',
			'initial': 'N'
		},
		{
			'id': '533300',
			'name': '怒江傈僳族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '怒江',
			'leveltype': 2,
			'citycode': '0886',
			'zipcode': '673100',
			'mergername': '中国,云南省,怒江傈僳族自治州',
			'lng': '98.854304',
			'lat': '25.850949',
			'pinyin': 'Nujiang',
			'initial': 'N'
		},
		{
			'id': '542400',
			'name': '那曲地区',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '那曲',
			'leveltype': 2,
			'citycode': '0896',
			'zipcode': '852000',
			'mergername': '中国,西藏自治区,那曲地区',
			'lng': '92.060214',
			'lat': '31.476004',
			'pinyin': 'Nagqu',
			'initial': 'N'
		},
		{
			'id': '542500',
			'name': '阿里地区',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '阿里',
			'leveltype': 2,
			'citycode': '0897',
			'zipcode': '859000',
			'mergername': '中国,西藏自治区,阿里地区',
			'lng': '80.105498',
			'lat': '32.503187',
			'pinyin': 'Ngari',
			'initial': 'N'
		},
		{
			'id': '542600',
			'name': '林芝地区',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '林芝',
			'leveltype': 2,
			'citycode': '0894',
			'zipcode': '850400',
			'mergername': '中国,西藏自治区,林芝地区',
			'lng': '94.362348',
			'lat': '29.654693',
			'pinyin': 'Nyingchi',
			'initial': 'N'
		},
		{
			'id': '150600',
			'name': '鄂尔多斯市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '鄂尔多斯',
			'leveltype': 2,
			'citycode': '0477',
			'zipcode': '017004',
			'mergername': '中国,内蒙古自治区,鄂尔多斯市',
			'lng': '109.99029',
			'lat': '39.817179',
			'pinyin': 'Ordos',
			'initial': 'O'
		},
		{
			'id': '211100',
			'name': '盘锦市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '盘锦',
			'leveltype': 2,
			'citycode': '0427',
			'zipcode': '124010',
			'mergername': '中国,辽宁省,盘锦市',
			'lng': '122.06957',
			'lat': '41.124484',
			'pinyin': 'Panjin',
			'initial': 'P'
		},
		{
			'id': '350300',
			'name': '莆田市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '莆田',
			'leveltype': 2,
			'citycode': '0594',
			'zipcode': '351100',
			'mergername': '中国,福建省,莆田市',
			'lng': '119.007558',
			'lat': '25.431011',
			'pinyin': 'Putian',
			'initial': 'P'
		},
		{
			'id': '360300',
			'name': '萍乡市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '萍乡',
			'leveltype': 2,
			'citycode': '0799',
			'zipcode': '337000',
			'mergername': '中国,江西省,萍乡市',
			'lng': '113.852186',
			'lat': '27.622946',
			'pinyin': 'Pingxiang',
			'initial': 'P'
		},
		{
			'id': '410400',
			'name': '平顶山市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '平顶山',
			'leveltype': 2,
			'citycode': '0375',
			'zipcode': '467000',
			'mergername': '中国,河南省,平顶山市',
			'lng': '113.307718',
			'lat': '33.735241',
			'pinyin': 'Pingdingshan',
			'initial': 'P'
		},
		{
			'id': '410900',
			'name': '濮阳市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '濮阳',
			'leveltype': 2,
			'citycode': '0393',
			'zipcode': '457000',
			'mergername': '中国,河南省,濮阳市',
			'lng': '115.041299',
			'lat': '35.768234',
			'pinyin': 'Puyang',
			'initial': 'P'
		},
		{
			'id': '510400',
			'name': '攀枝花市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '攀枝花',
			'leveltype': 2,
			'citycode': '0812',
			'zipcode': '617000',
			'mergername': '中国,四川省,攀枝花市',
			'lng': '101.716007',
			'lat': '26.580446',
			'pinyin': 'Panzhihua',
			'initial': 'P'
		},
		{
			'id': '530800',
			'name': '普洱市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '普洱',
			'leveltype': 2,
			'citycode': '0879',
			'zipcode': '665000',
			'mergername': '中国,云南省,普洱市',
			'lng': '100.972344',
			'lat': '22.777321',
			'pinyin': "Pu'er",
			'initial': 'P'
		},
		{
			'id': '620800',
			'name': '平凉市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '平凉',
			'leveltype': 2,
			'citycode': '0933',
			'zipcode': '744000',
			'mergername': '中国,甘肃省,平凉市',
			'lng': '106.684691',
			'lat': '35.54279',
			'pinyin': 'Pingliang',
			'initial': 'P'
		},
		{
			'id': '130300',
			'name': '秦皇岛市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '秦皇岛',
			'leveltype': 2,
			'citycode': '0335',
			'zipcode': '066000',
			'mergername': '中国,河北省,秦皇岛市',
			'lng': '119.586579',
			'lat': '39.942531',
			'pinyin': 'Qinhuangdao',
			'initial': 'Q'
		},
		{
			'id': '230200',
			'name': '齐齐哈尔市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '齐齐哈尔',
			'leveltype': 2,
			'citycode': '0452',
			'zipcode': '161005',
			'mergername': '中国,黑龙江省,齐齐哈尔市',
			'lng': '123.953486',
			'lat': '47.348079',
			'pinyin': 'Qiqihar',
			'initial': 'Q'
		},
		{
			'id': '230900',
			'name': '七台河市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '七台河',
			'leveltype': 2,
			'citycode': '0464',
			'zipcode': '154600',
			'mergername': '中国,黑龙江省,七台河市',
			'lng': '131.015584',
			'lat': '45.771266',
			'pinyin': 'Qitaihe',
			'initial': 'Q'
		},
		{
			'id': '330800',
			'name': '衢州市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '衢州',
			'leveltype': 2,
			'citycode': '0570',
			'zipcode': '324002',
			'mergername': '中国,浙江省,衢州市',
			'lng': '118.87263',
			'lat': '28.941708',
			'pinyin': 'Quzhou',
			'initial': 'Q'
		},
		{
			'id': '350500',
			'name': '泉州市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '泉州',
			'leveltype': 2,
			'citycode': '0595',
			'zipcode': '362000',
			'mergername': '中国,福建省,泉州市',
			'lng': '118.589421',
			'lat': '24.908853',
			'pinyin': 'Quanzhou',
			'initial': 'Q'
		},
		{
			'id': '370200',
			'name': '青岛市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '青岛',
			'leveltype': 2,
			'citycode': '0532',
			'zipcode': '266001',
			'mergername': '中国,山东省,青岛市',
			'lng': '120.369557',
			'lat': '36.094406',
			'pinyin': 'Qingdao',
			'initial': 'Q'
		},
		{
			'id': '441800',
			'name': '清远市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '清远',
			'leveltype': 2,
			'citycode': '0763',
			'zipcode': '511500',
			'mergername': '中国,广东省,清远市',
			'lng': '113.036779',
			'lat': '23.704188',
			'pinyin': 'Qingyuan',
			'initial': 'Q'
		},
		{
			'id': '450700',
			'name': '钦州市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '钦州',
			'leveltype': 2,
			'citycode': '0777',
			'zipcode': '535099',
			'mergername': '中国,广西壮族自治区,钦州市',
			'lng': '108.624175',
			'lat': '21.967127',
			'pinyin': 'Qinzhou',
			'initial': 'Q'
		},
		{
			'id': '522300',
			'name': '黔西南布依族苗族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '黔西南',
			'leveltype': 2,
			'citycode': '0859',
			'zipcode': '562400',
			'mergername': '中国,贵州省,黔西南布依族苗族自治州',
			'lng': '104.897971',
			'lat': '25.08812',
			'pinyin': 'Qianxinan',
			'initial': 'Q'
		},
		{
			'id': '522600',
			'name': '黔东南苗族侗族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '黔东南',
			'leveltype': 2,
			'citycode': '0855',
			'zipcode': '556000',
			'mergername': '中国,贵州省,黔东南苗族侗族自治州',
			'lng': '107.977488',
			'lat': '26.583352',
			'pinyin': 'Qiandongnan',
			'initial': 'Q'
		},
		{
			'id': '522700',
			'name': '黔南布依族苗族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '黔南',
			'leveltype': 2,
			'citycode': '0854',
			'zipcode': '558000',
			'mergername': '中国,贵州省,黔南布依族苗族自治州',
			'lng': '107.517156',
			'lat': '26.258219',
			'pinyin': 'Qiannan',
			'initial': 'Q'
		},
		{
			'id': '530300',
			'name': '曲靖市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '曲靖',
			'leveltype': 2,
			'citycode': '0874',
			'zipcode': '655000',
			'mergername': '中国,云南省,曲靖市',
			'lng': '103.797851',
			'lat': '25.501557',
			'pinyin': 'Qujing',
			'initial': 'Q'
		},
		{
			'id': '540300',
			'name': '昌都市',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '昌都',
			'leveltype': 2,
			'citycode': '0895',
			'zipcode': '854000',
			'mergername': '中国,西藏自治区,昌都市',
			'lng': '97.178452',
			'lat': '31.136875',
			'pinyin': 'Qamdo',
			'initial': 'Q'
		},
		{
			'id': '621000',
			'name': '庆阳市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '庆阳',
			'leveltype': 2,
			'citycode': '0934',
			'zipcode': '745000',
			'mergername': '中国,甘肃省,庆阳市',
			'lng': '107.638372',
			'lat': '35.734218',
			'pinyin': 'Qingyang',
			'initial': 'Q'
		},
		{
			'id': '654200',
			'name': '塔城地区',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '塔城',
			'leveltype': 2,
			'citycode': '0901',
			'zipcode': '834700',
			'mergername': '中国,新疆维吾尔自治区,塔城地区',
			'lng': '82.985732',
			'lat': '46.746301',
			'pinyin': 'Qoqek',
			'initial': 'Q'
		},
		{
			'id': '371100',
			'name': '日照市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '日照',
			'leveltype': 2,
			'citycode': '0633',
			'zipcode': '276800',
			'mergername': '中国,山东省,日照市',
			'lng': '119.461208',
			'lat': '35.428588',
			'pinyin': 'Rizhao',
			'initial': 'R'
		},
		{
			'id': '540200',
			'name': '日喀则市',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '日喀则',
			'leveltype': 2,
			'citycode': '0892',
			'zipcode': '857000',
			'mergername': '中国,西藏自治区,日喀则市',
			'lng': '88.884874',
			'lat': '29.263792',
			'pinyin': 'Rikaze',
			'initial': 'R'
		},
		{
			'id': '130100',
			'name': '石家庄市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '石家庄',
			'leveltype': 2,
			'citycode': '0311',
			'zipcode': '050011',
			'mergername': '中国,河北省,石家庄市',
			'lng': '114.502461',
			'lat': '38.045474',
			'pinyin': 'Shijiazhuang',
			'initial': 'S'
		},
		{
			'id': '140600',
			'name': '朔州市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '朔州',
			'leveltype': 2,
			'citycode': '0349',
			'zipcode': '038500',
			'mergername': '中国,山西省,朔州市',
			'lng': '112.433387',
			'lat': '39.331261',
			'pinyin': 'Shuozhou',
			'initial': 'S'
		},
		{
			'id': '210100',
			'name': '沈阳市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '沈阳',
			'leveltype': 2,
			'citycode': '024',
			'zipcode': '110013',
			'mergername': '中国,辽宁省,沈阳市',
			'lng': '123.429096',
			'lat': '41.796767',
			'pinyin': 'Shenyang',
			'initial': 'S'
		},
		{
			'id': '220300',
			'name': '四平市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '四平',
			'leveltype': 2,
			'citycode': '0434',
			'zipcode': '136000',
			'mergername': '中国,吉林省,四平市',
			'lng': '124.370785',
			'lat': '43.170344',
			'pinyin': 'Siping',
			'initial': 'S'
		},
		{
			'id': '220700',
			'name': '松原市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '松原',
			'leveltype': 2,
			'citycode': '0438',
			'zipcode': '138000',
			'mergername': '中国,吉林省,松原市',
			'lng': '124.823608',
			'lat': '45.118243',
			'pinyin': 'Songyuan',
			'initial': 'S'
		},
		{
			'id': '230500',
			'name': '双鸭山市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '双鸭山',
			'leveltype': 2,
			'citycode': '0469',
			'zipcode': '155100',
			'mergername': '中国,黑龙江省,双鸭山市',
			'lng': '131.157304',
			'lat': '46.643442',
			'pinyin': 'Shuangyashan',
			'initial': 'S'
		},
		{
			'id': '231200',
			'name': '绥化市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '绥化',
			'leveltype': 2,
			'citycode': '0455',
			'zipcode': '152000',
			'mergername': '中国,黑龙江省,绥化市',
			'lng': '126.99293',
			'lat': '46.637393',
			'pinyin': 'Suihua',
			'initial': 'S'
		},
		{
			'id': '310100',
			'name': '上海市',
			'areacode': null,
			'areaname': null,
			'pid': '310000',
			'shortname': '上海',
			'leveltype': 2,
			'citycode': '021',
			'zipcode': '200000',
			'mergername': '中国,上海,上海市',
			'lng': '121.472644',
			'lat': '31.231706',
			'pinyin': 'Shanghai',
			'initial': 'S'
		},
		{
			'id': '320500',
			'name': '苏州市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '苏州',
			'leveltype': 2,
			'citycode': '0512',
			'zipcode': '215002',
			'mergername': '中国,江苏省,苏州市',
			'lng': '120.619585',
			'lat': '31.299379',
			'pinyin': 'Suzhou',
			'initial': 'S'
		},
		{
			'id': '321300',
			'name': '宿迁市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '宿迁',
			'leveltype': 2,
			'citycode': '0527',
			'zipcode': '223800',
			'mergername': '中国,江苏省,宿迁市',
			'lng': '118.293328',
			'lat': '33.945154',
			'pinyin': 'Suqian',
			'initial': 'S'
		},
		{
			'id': '330600',
			'name': '绍兴市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '绍兴',
			'leveltype': 2,
			'citycode': '0575',
			'zipcode': '312000',
			'mergername': '中国,浙江省,绍兴市',
			'lng': '120.582112',
			'lat': '29.997117',
			'pinyin': 'Shaoxing',
			'initial': 'S'
		},
		{
			'id': '341300',
			'name': '宿州市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '宿州',
			'leveltype': 2,
			'citycode': '0557',
			'zipcode': '234000',
			'mergername': '中国,安徽省,宿州市',
			'lng': '116.984084',
			'lat': '33.633891',
			'pinyin': 'Suzhou',
			'initial': 'S'
		},
		{
			'id': '350400',
			'name': '三明市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '三明',
			'leveltype': 2,
			'citycode': '0598',
			'zipcode': '365000',
			'mergername': '中国,福建省,三明市',
			'lng': '117.635001',
			'lat': '26.265444',
			'pinyin': 'Sanming',
			'initial': 'S'
		},
		{
			'id': '361100',
			'name': '上饶市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '上饶',
			'leveltype': 2,
			'citycode': '0793',
			'zipcode': '334000',
			'mergername': '中国,江西省,上饶市',
			'lng': '117.971185',
			'lat': '28.44442',
			'pinyin': 'Shangrao',
			'initial': 'S'
		},
		{
			'id': '411200',
			'name': '三门峡市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '三门峡',
			'leveltype': 2,
			'citycode': '0398',
			'zipcode': '472000',
			'mergername': '中国,河南省,三门峡市',
			'lng': '111.194099',
			'lat': '34.777338',
			'pinyin': 'Sanmenxia',
			'initial': 'S'
		},
		{
			'id': '411400',
			'name': '商丘市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '商丘',
			'leveltype': 2,
			'citycode': '0370',
			'zipcode': '476000',
			'mergername': '中国,河南省,商丘市',
			'lng': '115.650497',
			'lat': '34.437054',
			'pinyin': 'Shangqiu',
			'initial': 'S'
		},
		{
			'id': '420300',
			'name': '十堰市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '十堰',
			'leveltype': 2,
			'citycode': '0719',
			'zipcode': '442000',
			'mergername': '中国,湖北省,十堰市',
			'lng': '110.785239',
			'lat': '32.647017',
			'pinyin': 'Shiyan',
			'initial': 'S'
		},
		{
			'id': '421300',
			'name': '随州市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '随州',
			'leveltype': 2,
			'citycode': '0722',
			'zipcode': '441300',
			'mergername': '中国,湖北省,随州市',
			'lng': '113.37377',
			'lat': '31.717497',
			'pinyin': 'Suizhou',
			'initial': 'S'
		},
		{
			'id': '430500',
			'name': '邵阳市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '邵阳',
			'leveltype': 2,
			'citycode': '0739',
			'zipcode': '422000',
			'mergername': '中国,湖南省,邵阳市',
			'lng': '111.46923',
			'lat': '27.237842',
			'pinyin': 'Shaoyang',
			'initial': 'S'
		},
		{
			'id': '440200',
			'name': '韶关市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '韶关',
			'leveltype': 2,
			'citycode': '0751',
			'zipcode': '512002',
			'mergername': '中国,广东省,韶关市',
			'lng': '113.591544',
			'lat': '24.801322',
			'pinyin': 'Shaoguan',
			'initial': 'S'
		},
		{
			'id': '440300',
			'name': '深圳市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '深圳',
			'leveltype': 2,
			'citycode': '0755',
			'zipcode': '518035',
			'mergername': '中国,广东省,深圳市',
			'lng': '114.085947',
			'lat': '22.547',
			'pinyin': 'Shenzhen',
			'initial': 'S'
		},
		{
			'id': '440500',
			'name': '汕头市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '汕头',
			'leveltype': 2,
			'citycode': '0754',
			'zipcode': '515041',
			'mergername': '中国,广东省,汕头市',
			'lng': '116.708463',
			'lat': '23.37102',
			'pinyin': 'Shantou',
			'initial': 'S'
		},
		{
			'id': '441500',
			'name': '汕尾市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '汕尾',
			'leveltype': 2,
			'citycode': '0660',
			'zipcode': '516600',
			'mergername': '中国,广东省,汕尾市',
			'lng': '115.364238',
			'lat': '22.774485',
			'pinyin': 'Shanwei',
			'initial': 'S'
		},
		{
			'id': '460200',
			'name': '三亚市',
			'areacode': null,
			'areaname': null,
			'pid': '460000',
			'shortname': '三亚',
			'leveltype': 2,
			'citycode': '0898',
			'zipcode': '572000',
			'mergername': '中国,海南省,三亚市',
			'lng': '109.508268',
			'lat': '18.247872',
			'pinyin': 'Sanya',
			'initial': 'S'
		},
		{
			'id': '460300',
			'name': '三沙市',
			'areacode': null,
			'areaname': null,
			'pid': '460000',
			'shortname': '三沙',
			'leveltype': 2,
			'citycode': '0898',
			'zipcode': '573199',
			'mergername': '中国,海南省,三沙市',
			'lng': '112.34882',
			'lat': '16.831039',
			'pinyin': 'Sansha',
			'initial': 'S'
		},
		{
			'id': '510900',
			'name': '遂宁市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '遂宁',
			'leveltype': 2,
			'citycode': '0825',
			'zipcode': '629000',
			'mergername': '中国,四川省,遂宁市',
			'lng': '105.571331',
			'lat': '30.513311',
			'pinyin': 'Suining',
			'initial': 'S'
		},
		{
			'id': '542200',
			'name': '山南地区',
			'areacode': null,
			'areaname': null,
			'pid': '540000',
			'shortname': '山南',
			'leveltype': 2,
			'citycode': '0893',
			'zipcode': '856000',
			'mergername': '中国,西藏自治区,山南地区',
			'lng': '91.766529',
			'lat': '29.236023',
			'pinyin': 'Shannan',
			'initial': 'S'
		},
		{
			'id': '611000',
			'name': '商洛市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '商洛',
			'leveltype': 2,
			'citycode': '0914',
			'zipcode': '726000',
			'mergername': '中国,陕西省,商洛市',
			'lng': '109.939776',
			'lat': '33.868319',
			'pinyin': 'Shangluo',
			'initial': 'S'
		},
		{
			'id': '640200',
			'name': '石嘴山市',
			'areacode': null,
			'areaname': null,
			'pid': '640000',
			'shortname': '石嘴山',
			'leveltype': 2,
			'citycode': '0952',
			'zipcode': '753000',
			'mergername': '中国,宁夏回族自治区,石嘴山市',
			'lng': '106.376173',
			'lat': '39.01333',
			'pinyin': 'Shizuishan',
			'initial': 'S'
		},
		{
			'id': '120100',
			'name': '天津市',
			'areacode': null,
			'areaname': null,
			'pid': '120000',
			'shortname': '天津',
			'leveltype': 2,
			'citycode': '022',
			'zipcode': '300000',
			'mergername': '中国,天津,天津市',
			'lng': '117.190182',
			'lat': '39.125596',
			'pinyin': 'Tianjin',
			'initial': 'T'
		},
		{
			'id': '130200',
			'name': '唐山市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '唐山',
			'leveltype': 2,
			'citycode': '0315',
			'zipcode': '063000',
			'mergername': '中国,河北省,唐山市',
			'lng': '118.175393',
			'lat': '39.635113',
			'pinyin': 'Tangshan',
			'initial': 'T'
		},
		{
			'id': '140100',
			'name': '太原市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '太原',
			'leveltype': 2,
			'citycode': '0351',
			'zipcode': '030082',
			'mergername': '中国,山西省,太原市',
			'lng': '112.549248',
			'lat': '37.857014',
			'pinyin': 'Taiyuan',
			'initial': 'T'
		},
		{
			'id': '150500',
			'name': '通辽市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '通辽',
			'leveltype': 2,
			'citycode': '0475',
			'zipcode': '028000',
			'mergername': '中国,内蒙古自治区,通辽市',
			'lng': '122.263119',
			'lat': '43.617429',
			'pinyin': 'Tongliao',
			'initial': 'T'
		},
		{
			'id': '211200',
			'name': '铁岭市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '铁岭',
			'leveltype': 2,
			'citycode': '024',
			'zipcode': '112000',
			'mergername': '中国,辽宁省,铁岭市',
			'lng': '123.844279',
			'lat': '42.290585',
			'pinyin': 'Tieling',
			'initial': 'T'
		},
		{
			'id': '220500',
			'name': '通化市',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '通化',
			'leveltype': 2,
			'citycode': '0435',
			'zipcode': '134001',
			'mergername': '中国,吉林省,通化市',
			'lng': '125.936501',
			'lat': '41.721177',
			'pinyin': 'Tonghua',
			'initial': 'T'
		},
		{
			'id': '321200',
			'name': '泰州市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '泰州',
			'leveltype': 2,
			'citycode': '0523',
			'zipcode': '225300',
			'mergername': '中国,江苏省,泰州市',
			'lng': '119.915176',
			'lat': '32.484882',
			'pinyin': 'Taizhou',
			'initial': 'T'
		},
		{
			'id': '331000',
			'name': '台州市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '台州',
			'leveltype': 2,
			'citycode': '0576',
			'zipcode': '318000',
			'mergername': '中国,浙江省,台州市',
			'lng': '121.428599',
			'lat': '28.661378',
			'pinyin': 'Taizhou',
			'initial': 'T'
		},
		{
			'id': '340700',
			'name': '铜陵市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '铜陵',
			'leveltype': 2,
			'citycode': '0562',
			'zipcode': '244000',
			'mergername': '中国,安徽省,铜陵市',
			'lng': '117.816576',
			'lat': '30.929935',
			'pinyin': 'Tongling',
			'initial': 'T'
		},
		{
			'id': '370900',
			'name': '泰安市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '泰安',
			'leveltype': 2,
			'citycode': '0538',
			'zipcode': '271000',
			'mergername': '中国,山东省,泰安市',
			'lng': '117.129063',
			'lat': '36.194968',
			'pinyin': "Tai'an",
			'initial': 'T'
		},
		{
			'id': '520600',
			'name': '铜仁市',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '铜仁',
			'leveltype': 2,
			'citycode': '0856',
			'zipcode': '554300',
			'mergername': '中国,贵州省,铜仁市',
			'lng': '109.191555',
			'lat': '27.718346',
			'pinyin': 'Tongren',
			'initial': 'T'
		},
		{
			'id': '610200',
			'name': '铜川市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '铜川',
			'leveltype': 2,
			'citycode': '0919',
			'zipcode': '727100',
			'mergername': '中国,陕西省,铜川市',
			'lng': '108.963122',
			'lat': '34.90892',
			'pinyin': 'Tongchuan',
			'initial': 'T'
		},
		{
			'id': '620500',
			'name': '天水市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '天水',
			'leveltype': 2,
			'citycode': '0938',
			'zipcode': '741000',
			'mergername': '中国,甘肃省,天水市',
			'lng': '105.724998',
			'lat': '34.578529',
			'pinyin': 'Tianshui',
			'initial': 'T'
		},
		{
			'id': '650400',
			'name': '吐鲁番市',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '吐鲁番',
			'leveltype': 2,
			'citycode': '0995',
			'zipcode': '838000',
			'mergername': '中国,新疆维吾尔自治区,吐鲁番市',
			'lng': '89.184078',
			'lat': '42.947613',
			'pinyin': 'Turpan',
			'initial': 'T'
		},
		// {
		// 	'id': '652100',
		// 	'name': '吐鲁番地区',
		// 	'areacode': null,
		// 	'areaname': null,
		// 	'pid': '650000',
		// 	'shortname': '吐鲁番',
		// 	'leveltype': 2,
		// 	'citycode': '0995',
		// 	'zipcode': '838000',
		// 	'mergername': '中国,新疆维吾尔自治区,吐鲁番地区',
		// 	'lng': '89.184078',
		// 	'lat': '42.947613',
		// 	'pinyin': 'Turpan',
		// 	'initial': 'T'
		// },
		{
			'id': '150900',
			'name': '乌兰察布市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '乌兰察布',
			'leveltype': 2,
			'citycode': '0474',
			'zipcode': '012000',
			'mergername': '中国,内蒙古自治区,乌兰察布市',
			'lng': '113.114543',
			'lat': '41.034126',
			'pinyin': 'Ulanqab',
			'initial': 'U'
		},
		{
			'id': '650100',
			'name': '乌鲁木齐市',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '乌鲁木齐',
			'leveltype': 2,
			'citycode': '0991',
			'zipcode': '830002',
			'mergername': '中国,新疆维吾尔自治区,乌鲁木齐市',
			'lng': '87.617733',
			'lat': '43.792818',
			'pinyin': 'Urumqi',
			'initial': 'U'
		},
		{
			'id': '150300',
			'name': '乌海市',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '乌海',
			'leveltype': 2,
			'citycode': '0473',
			'zipcode': '016000',
			'mergername': '中国,内蒙古自治区,乌海市',
			'lng': '106.825563',
			'lat': '39.673734',
			'pinyin': 'Wuhai',
			'initial': 'W'
		},
		{
			'id': '320200',
			'name': '无锡市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '无锡',
			'leveltype': 2,
			'citycode': '0510',
			'zipcode': '214000',
			'mergername': '中国,江苏省,无锡市',
			'lng': '120.301663',
			'lat': '31.574729',
			'pinyin': 'Wuxi',
			'initial': 'W'
		},
		{
			'id': '330300',
			'name': '温州市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '温州',
			'leveltype': 2,
			'citycode': '0577',
			'zipcode': '325000',
			'mergername': '中国,浙江省,温州市',
			'lng': '120.672111',
			'lat': '28.000575',
			'pinyin': 'Wenzhou',
			'initial': 'W'
		},
		{
			'id': '340200',
			'name': '芜湖市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '芜湖',
			'leveltype': 2,
			'citycode': '0551',
			'zipcode': '241000',
			'mergername': '中国,安徽省,芜湖市',
			'lng': '118.376451',
			'lat': '31.326319',
			'pinyin': 'Wuhu',
			'initial': 'W'
		},
		{
			'id': '370700',
			'name': '潍坊市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '潍坊',
			'leveltype': 2,
			'citycode': '0536',
			'zipcode': '261041',
			'mergername': '中国,山东省,潍坊市',
			'lng': '119.107078',
			'lat': '36.70925',
			'pinyin': 'Weifang',
			'initial': 'W'
		},
		{
			'id': '371000',
			'name': '威海市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '威海',
			'leveltype': 2,
			'citycode': '0631',
			'zipcode': '264200',
			'mergername': '中国,山东省,威海市',
			'lng': '122.116394',
			'lat': '37.509691',
			'pinyin': 'Weihai',
			'initial': 'W'
		},
		{
			'id': '420100',
			'name': '武汉市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '武汉',
			'leveltype': 2,
			'citycode': null,
			'zipcode': '430014',
			'mergername': '中国,湖北省,武汉市',
			'lng': '114.298572',
			'lat': '30.584355',
			'pinyin': 'Wuhan',
			'initial': 'W'
		},
		{
			'id': '450400',
			'name': '梧州市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '梧州',
			'leveltype': 2,
			'citycode': '0774',
			'zipcode': '543002',
			'mergername': '中国,广西壮族自治区,梧州市',
			'lng': '111.316229',
			'lat': '23.472309',
			'pinyin': 'Wuzhou',
			'initial': 'W'
		},
		{
			'id': '532600',
			'name': '文山壮族苗族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '文山',
			'leveltype': 2,
			'citycode': '0876',
			'zipcode': '663000',
			'mergername': '中国,云南省,文山壮族苗族自治州',
			'lng': '104.24401',
			'lat': '23.36951',
			'pinyin': 'Wenshan',
			'initial': 'W'
		},
		{
			'id': '610500',
			'name': '渭南市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '渭南',
			'leveltype': 2,
			'citycode': '0913',
			'zipcode': '714000',
			'mergername': '中国,陕西省,渭南市',
			'lng': '109.502882',
			'lat': '34.499381',
			'pinyin': 'Weinan',
			'initial': 'W'
		},
		{
			'id': '620600',
			'name': '武威市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '武威',
			'leveltype': 2,
			'citycode': '0935',
			'zipcode': '733000',
			'mergername': '中国,甘肃省,武威市',
			'lng': '102.634697',
			'lat': '37.929996',
			'pinyin': 'Wuwei',
			'initial': 'W'
		},
		{
			'id': '640300',
			'name': '吴忠市',
			'areacode': null,
			'areaname': null,
			'pid': '640000',
			'shortname': '吴忠',
			'leveltype': 2,
			'citycode': '0953',
			'zipcode': '751100',
			'mergername': '中国,宁夏回族自治区,吴忠市',
			'lng': '106.199409',
			'lat': '37.986165',
			'pinyin': 'Wuzhong',
			'initial': 'W'
		},
		{
			'id': '130500',
			'name': '邢台市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '邢台',
			'leveltype': 2,
			'citycode': '0319',
			'zipcode': '054001',
			'mergername': '中国,河北省,邢台市',
			'lng': '114.508851',
			'lat': '37.0682',
			'pinyin': 'Xingtai',
			'initial': 'X'
		},
		{
			'id': '140900',
			'name': '忻州市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '忻州',
			'leveltype': 2,
			'citycode': '0350',
			'zipcode': '034000',
			'mergername': '中国,山西省,忻州市',
			'lng': '112.733538',
			'lat': '38.41769',
			'pinyin': 'Xinzhou',
			'initial': 'X'
		},
		{
			'id': '152500',
			'name': '锡林郭勒盟',
			'areacode': null,
			'areaname': null,
			'pid': '150000',
			'shortname': '锡林郭勒盟',
			'leveltype': 2,
			'citycode': '0479',
			'zipcode': '026000',
			'mergername': '中国,内蒙古自治区,锡林郭勒盟',
			'lng': '116.090996',
			'lat': '43.944018',
			'pinyin': 'Xilin Gol',
			'initial': 'X'
		},
		{
			'id': '320300',
			'name': '徐州市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '徐州',
			'leveltype': 2,
			'citycode': '0516',
			'zipcode': '221003',
			'mergername': '中国,江苏省,徐州市',
			'lng': '117.184811',
			'lat': '34.261792',
			'pinyin': 'Xuzhou',
			'initial': 'X'
		},
		{
			'id': '341800',
			'name': '宣城市',
			'areacode': null,
			'areaname': null,
			'pid': '340000',
			'shortname': '宣城',
			'leveltype': 2,
			'citycode': '0563',
			'zipcode': '242000',
			'mergername': '中国,安徽省,宣城市',
			'lng': '118.757995',
			'lat': '30.945667',
			'pinyin': 'Xuancheng',
			'initial': 'X'
		},
		{
			'id': '350200',
			'name': '厦门市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '厦门',
			'leveltype': 2,
			'citycode': '0592',
			'zipcode': '361003',
			'mergername': '中国,福建省,厦门市',
			'lng': '118.11022',
			'lat': '24.490474',
			'pinyin': 'Xiamen',
			'initial': 'X'
		},
		{
			'id': '360500',
			'name': '新余市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '新余',
			'leveltype': 2,
			'citycode': '0790',
			'zipcode': '338025',
			'mergername': '中国,江西省,新余市',
			'lng': '114.930835',
			'lat': '27.810834',
			'pinyin': 'Xinyu',
			'initial': 'X'
		},
		{
			'id': '410700',
			'name': '新乡市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '新乡',
			'leveltype': 2,
			'citycode': '0373',
			'zipcode': '453000',
			'mergername': '中国,河南省,新乡市',
			'lng': '113.883991',
			'lat': '35.302616',
			'pinyin': 'Xinxiang',
			'initial': 'X'
		},
		{
			'id': '411000',
			'name': '许昌市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '许昌',
			'leveltype': 2,
			'citycode': '0374',
			'zipcode': '461000',
			'mergername': '中国,河南省,许昌市',
			'lng': '113.826063',
			'lat': '34.022956',
			'pinyin': 'Xuchang',
			'initial': 'X'
		},
		{
			'id': '411500',
			'name': '信阳市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '信阳',
			'leveltype': 2,
			'citycode': '0376',
			'zipcode': '464000',
			'mergername': '中国,河南省,信阳市',
			'lng': '114.075031',
			'lat': '32.123274',
			'pinyin': 'Xinyang',
			'initial': 'X'
		},
		{
			'id': '420600',
			'name': '襄阳市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '襄阳',
			'leveltype': 2,
			'citycode': '0710',
			'zipcode': '441021',
			'mergername': '中国,湖北省,襄阳市',
			'lng': '112.144146',
			'lat': '32.042426',
			'pinyin': 'Xiangyang',
			'initial': 'X'
		},
		{
			'id': '420900',
			'name': '孝感市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '孝感',
			'leveltype': 2,
			'citycode': '0712',
			'zipcode': '432100',
			'mergername': '中国,湖北省,孝感市',
			'lng': '113.926655',
			'lat': '30.926423',
			'pinyin': 'Xiaogan',
			'initial': 'X'
		},
		{
			'id': '421200',
			'name': '咸宁市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '咸宁',
			'leveltype': 2,
			'citycode': '0715',
			'zipcode': '437000',
			'mergername': '中国,湖北省,咸宁市',
			'lng': '114.328963',
			'lat': '29.832798',
			'pinyin': 'Xianning',
			'initial': 'X'
		},
		{
			'id': '430300',
			'name': '湘潭市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '湘潭',
			'leveltype': 2,
			'citycode': '0731',
			'zipcode': '411100',
			'mergername': '中国,湖南省,湘潭市',
			'lng': '112.925083',
			'lat': '27.846725',
			'pinyin': 'Xiangtan',
			'initial': 'X'
		},
		{
			'id': '433100',
			'name': '湘西土家族苗族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '湘西',
			'leveltype': 2,
			'citycode': '0743',
			'zipcode': '416000',
			'mergername': '中国,湖南省,湘西土家族苗族自治州',
			'lng': '109.739735',
			'lat': '28.314296',
			'pinyin': 'Xiangxi',
			'initial': 'X'
		},
		{
			'id': '532800',
			'name': '西双版纳傣族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '西双版纳',
			'leveltype': 2,
			'citycode': '0691',
			'zipcode': '666100',
			'mergername': '中国,云南省,西双版纳傣族自治州',
			'lng': '100.797941',
			'lat': '22.001724',
			'pinyin': 'Xishuangbanna',
			'initial': 'X'
		},
		{
			'id': '610100',
			'name': '西安市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '西安',
			'leveltype': 2,
			'citycode': '029',
			'zipcode': '710003',
			'mergername': '中国,陕西省,西安市',
			'lng': '108.948024',
			'lat': '34.263161',
			'pinyin': "Xi'an",
			'initial': 'X'
		},
		{
			'id': '610400',
			'name': '咸阳市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '咸阳',
			'leveltype': 2,
			'citycode': '029',
			'zipcode': '712000',
			'mergername': '中国,陕西省,咸阳市',
			'lng': '108.705117',
			'lat': '34.333439',
			'pinyin': 'Xianyang',
			'initial': 'X'
		},
		{
			'id': '611100',
			'name': '西咸新区',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '西咸',
			'leveltype': 2,
			'citycode': '029',
			'zipcode': '712000',
			'mergername': '中国,陕西省,西咸新区',
			'lng': '108.810654',
			'lat': '34.307144',
			'pinyin': 'Xixian',
			'initial': 'X'
		},
		{
			'id': '630100',
			'name': '西宁市',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '西宁',
			'leveltype': 2,
			'citycode': '0971',
			'zipcode': '810000',
			'mergername': '中国,青海省,西宁市',
			'lng': '101.778916',
			'lat': '36.623178',
			'pinyin': 'Xining',
			'initial': 'X'
		},
		{
			'id': '140300',
			'name': '阳泉市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '阳泉',
			'leveltype': 2,
			'citycode': '0353',
			'zipcode': '045000',
			'mergername': '中国,山西省,阳泉市',
			'lng': '113.583285',
			'lat': '37.861188',
			'pinyin': 'Yangquan',
			'initial': 'Y'
		},
		{
			'id': '140800',
			'name': '运城市',
			'areacode': null,
			'areaname': null,
			'pid': '140000',
			'shortname': '运城',
			'leveltype': 2,
			'citycode': '0359',
			'zipcode': '044000',
			'mergername': '中国,山西省,运城市',
			'lng': '111.003957',
			'lat': '35.022778',
			'pinyin': 'Yuncheng',
			'initial': 'Y'
		},
		{
			'id': '210800',
			'name': '营口市',
			'areacode': null,
			'areaname': null,
			'pid': '210000',
			'shortname': '营口',
			'leveltype': 2,
			'citycode': '0417',
			'zipcode': '115003',
			'mergername': '中国,辽宁省,营口市',
			'lng': '122.235151',
			'lat': '40.667432',
			'pinyin': 'Yingkou',
			'initial': 'Y'
		},
		{
			'id': '222400',
			'name': '延边朝鲜族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '220000',
			'shortname': '延边',
			'leveltype': 2,
			'citycode': '0433',
			'zipcode': '133000',
			'mergername': '中国,吉林省,延边朝鲜族自治州',
			'lng': '129.513228',
			'lat': '42.904823',
			'pinyin': 'Yanbian',
			'initial': 'Y'
		},
		{
			'id': '230700',
			'name': '伊春市',
			'areacode': null,
			'areaname': null,
			'pid': '230000',
			'shortname': '伊春',
			'leveltype': 2,
			'citycode': '0458',
			'zipcode': '153000',
			'mergername': '中国,黑龙江省,伊春市',
			'lng': '128.899396',
			'lat': '47.724775',
			'pinyin': 'Yichun',
			'initial': 'Y'
		},
		{
			'id': '320900',
			'name': '盐城市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '盐城',
			'leveltype': 2,
			'citycode': '0515',
			'zipcode': '224005',
			'mergername': '中国,江苏省,盐城市',
			'lng': '120.139998',
			'lat': '33.377631',
			'pinyin': 'Yancheng',
			'initial': 'Y'
		},
		{
			'id': '321000',
			'name': '扬州市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '扬州',
			'leveltype': 2,
			'citycode': '0514',
			'zipcode': '225002',
			'mergername': '中国,江苏省,扬州市',
			'lng': '119.421003',
			'lat': '32.393159',
			'pinyin': 'Yangzhou',
			'initial': 'Y'
		},
		{
			'id': '360600',
			'name': '鹰潭市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '鹰潭',
			'leveltype': 2,
			'citycode': '0701',
			'zipcode': '335000',
			'mergername': '中国,江西省,鹰潭市',
			'lng': '117.033838',
			'lat': '28.238638',
			'pinyin': 'Yingtan',
			'initial': 'Y'
		},
		{
			'id': '360900',
			'name': '宜春市',
			'areacode': null,
			'areaname': null,
			'pid': '360000',
			'shortname': '宜春',
			'leveltype': 2,
			'citycode': '0795',
			'zipcode': '336000',
			'mergername': '中国,江西省,宜春市',
			'lng': '114.391136',
			'lat': '27.8043',
			'pinyin': 'Yichun',
			'initial': 'Y'
		},
		{
			'id': '370600',
			'name': '烟台市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '烟台',
			'leveltype': 2,
			'citycode': '0635',
			'zipcode': '264010',
			'mergername': '中国,山东省,烟台市',
			'lng': '121.391382',
			'lat': '37.539297',
			'pinyin': 'Yantai',
			'initial': 'Y'
		},
		{
			'id': '420500',
			'name': '宜昌市',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '宜昌',
			'leveltype': 2,
			'citycode': '0717',
			'zipcode': '443000',
			'mergername': '中国,湖北省,宜昌市',
			'lng': '111.290843',
			'lat': '30.702636',
			'pinyin': 'Yichang',
			'initial': 'Y'
		},
		{
			'id': '430600',
			'name': '岳阳市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '岳阳',
			'leveltype': 2,
			'citycode': '0730',
			'zipcode': '414000',
			'mergername': '中国,湖南省,岳阳市',
			'lng': '113.132855',
			'lat': '29.37029',
			'pinyin': 'Yueyang',
			'initial': 'Y'
		},
		{
			'id': '430900',
			'name': '益阳市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '益阳',
			'leveltype': 2,
			'citycode': '0737',
			'zipcode': '413000',
			'mergername': '中国,湖南省,益阳市',
			'lng': '112.355042',
			'lat': '28.570066',
			'pinyin': 'Yiyang',
			'initial': 'Y'
		},
		{
			'id': '431100',
			'name': '永州市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '永州',
			'leveltype': 2,
			'citycode': '0746',
			'zipcode': '425000',
			'mergername': '中国,湖南省,永州市',
			'lng': '111.608019',
			'lat': '26.434516',
			'pinyin': 'Yongzhou',
			'initial': 'Y'
		},
		{
			'id': '441700',
			'name': '阳江市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '阳江',
			'leveltype': 2,
			'citycode': '0662',
			'zipcode': '529500',
			'mergername': '中国,广东省,阳江市',
			'lng': '111.975107',
			'lat': '21.859222',
			'pinyin': 'Yangjiang',
			'initial': 'Y'
		},
		{
			'id': '445300',
			'name': '云浮市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '云浮',
			'leveltype': 2,
			'citycode': '0766',
			'zipcode': '527300',
			'mergername': '中国,广东省,云浮市',
			'lng': '112.044439',
			'lat': '22.929801',
			'pinyin': 'Yunfu',
			'initial': 'Y'
		},
		{
			'id': '450900',
			'name': '玉林市',
			'areacode': null,
			'areaname': null,
			'pid': '450000',
			'shortname': '玉林',
			'leveltype': 2,
			'citycode': '0775',
			'zipcode': '537000',
			'mergername': '中国,广西壮族自治区,玉林市',
			'lng': '110.154393',
			'lat': '22.63136',
			'pinyin': 'Yulin',
			'initial': 'Y'
		},
		{
			'id': '511500',
			'name': '宜宾市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '宜宾',
			'leveltype': 2,
			'citycode': '0831',
			'zipcode': '644000',
			'mergername': '中国,四川省,宜宾市',
			'lng': '104.630825',
			'lat': '28.760189',
			'pinyin': 'Yibin',
			'initial': 'Y'
		},
		{
			'id': '511800',
			'name': '雅安市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '雅安',
			'leveltype': 2,
			'citycode': '0835',
			'zipcode': '625000',
			'mergername': '中国,四川省,雅安市',
			'lng': '103.001033',
			'lat': '29.987722',
			'pinyin': "Ya'an",
			'initial': 'Y'
		},
		{
			'id': '530400',
			'name': '玉溪市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '玉溪',
			'leveltype': 2,
			'citycode': '0877',
			'zipcode': '653100',
			'mergername': '中国,云南省,玉溪市',
			'lng': '102.543907',
			'lat': '24.350461',
			'pinyin': 'Yuxi',
			'initial': 'Y'
		},
		{
			'id': '610600',
			'name': '延安市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '延安',
			'leveltype': 2,
			'citycode': '0911',
			'zipcode': '716000',
			'mergername': '中国,陕西省,延安市',
			'lng': '109.49081',
			'lat': '36.596537',
			'pinyin': "Yan'an",
			'initial': 'Y'
		},
		{
			'id': '610800',
			'name': '榆林市',
			'areacode': null,
			'areaname': null,
			'pid': '610000',
			'shortname': '榆林',
			'leveltype': 2,
			'citycode': '0912',
			'zipcode': '719000',
			'mergername': '中国,陕西省,榆林市',
			'lng': '109.741193',
			'lat': '38.290162',
			'pinyin': 'Yulin',
			'initial': 'Y'
		},
		{
			'id': '632700',
			'name': '玉树藏族自治州',
			'areacode': null,
			'areaname': null,
			'pid': '630000',
			'shortname': '玉树',
			'leveltype': 2,
			'citycode': '0976',
			'zipcode': '815000',
			'mergername': '中国,青海省,玉树藏族自治州',
			'lng': '97.008522',
			'lat': '33.004049',
			'pinyin': 'Yushu',
			'initial': 'Y'
		},
		{
			'id': '640100',
			'name': '银川市',
			'areacode': null,
			'areaname': null,
			'pid': '640000',
			'shortname': '银川',
			'leveltype': 2,
			'citycode': '0951',
			'zipcode': '750004',
			'mergername': '中国,宁夏回族自治区,银川市',
			'lng': '106.278179',
			'lat': '38.46637',
			'pinyin': 'Yinchuan',
			'initial': 'Y'
		},
		{
			'id': '130700',
			'name': '张家口市',
			'areacode': null,
			'areaname': null,
			'pid': '130000',
			'shortname': '张家口',
			'leveltype': 2,
			'citycode': '0313',
			'zipcode': '075000',
			'mergername': '中国,河北省,张家口市',
			'lng': '114.884091',
			'lat': '40.811901',
			'pinyin': 'Zhangjiakou',
			'initial': 'Z'
		},
		{
			'id': '321100',
			'name': '镇江市',
			'areacode': null,
			'areaname': null,
			'pid': '320000',
			'shortname': '镇江',
			'leveltype': 2,
			'citycode': '0511',
			'zipcode': '212004',
			'mergername': '中国,江苏省,镇江市',
			'lng': '119.452753',
			'lat': '32.204402',
			'pinyin': 'Zhenjiang',
			'initial': 'Z'
		},
		{
			'id': '330900',
			'name': '舟山市',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '舟山',
			'leveltype': 2,
			'citycode': '0580',
			'zipcode': '316000',
			'mergername': '中国,浙江省,舟山市',
			'lng': '122.106863',
			'lat': '30.016028',
			'pinyin': 'Zhoushan',
			'initial': 'Z'
		},
		{
			'id': '331200',
			'name': '舟山群岛新区',
			'areacode': null,
			'areaname': null,
			'pid': '330000',
			'shortname': '舟山新区',
			'leveltype': 2,
			'citycode': '0580',
			'zipcode': '316000',
			'mergername': '中国,浙江省,舟山群岛新区',
			'lng': '122.317657',
			'lat': '29.813242',
			'pinyin': 'Zhoushan',
			'initial': 'Z'
		},
		{
			'id': '350600',
			'name': '漳州市',
			'areacode': null,
			'areaname': null,
			'pid': '350000',
			'shortname': '漳州',
			'leveltype': 2,
			'citycode': '0596',
			'zipcode': '363005',
			'mergername': '中国,福建省,漳州市',
			'lng': '117.661801',
			'lat': '24.510897',
			'pinyin': 'Zhangzhou',
			'initial': 'Z'
		},
		{
			'id': '370300',
			'name': '淄博市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '淄博',
			'leveltype': 2,
			'citycode': '0533',
			'zipcode': '255039',
			'mergername': '中国,山东省,淄博市',
			'lng': '118.047648',
			'lat': '36.814939',
			'pinyin': 'Zibo',
			'initial': 'Z'
		},
		{
			'id': '370400',
			'name': '枣庄市',
			'areacode': null,
			'areaname': null,
			'pid': '370000',
			'shortname': '枣庄',
			'leveltype': 2,
			'citycode': '0632',
			'zipcode': '277101',
			'mergername': '中国,山东省,枣庄市',
			'lng': '117.557964',
			'lat': '34.856424',
			'pinyin': 'Zaozhuang',
			'initial': 'Z'
		},
		{
			'id': '410100',
			'name': '郑州市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '郑州',
			'leveltype': 2,
			'citycode': '0371',
			'zipcode': '450000',
			'mergername': '中国,河南省,郑州市',
			'lng': '113.665412',
			'lat': '34.757975',
			'pinyin': 'Zhengzhou',
			'initial': 'Z'
		},
		{
			'id': '411600',
			'name': '周口市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '周口',
			'leveltype': 2,
			'citycode': '0394',
			'zipcode': '466000',
			'mergername': '中国,河南省,周口市',
			'lng': '114.649653',
			'lat': '33.620357',
			'pinyin': 'Zhoukou',
			'initial': 'Z'
		},
		{
			'id': '411700',
			'name': '驻马店市',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '驻马店',
			'leveltype': 2,
			'citycode': '0396',
			'zipcode': '463000',
			'mergername': '中国,河南省,驻马店市',
			'lng': '114.024736',
			'lat': '32.980169',
			'pinyin': 'Zhumadian',
			'initial': 'Z'
		},
		{
			'id': '430200',
			'name': '株洲市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '株洲',
			'leveltype': 2,
			'citycode': '0731',
			'zipcode': '412000',
			'mergername': '中国,湖南省,株洲市',
			'lng': '113.151737',
			'lat': '27.835806',
			'pinyin': 'Zhuzhou',
			'initial': 'Z'
		},
		{
			'id': '430800',
			'name': '张家界市',
			'areacode': null,
			'areaname': null,
			'pid': '430000',
			'shortname': '张家界',
			'leveltype': 2,
			'citycode': '0744',
			'zipcode': '427000',
			'mergername': '中国,湖南省,张家界市',
			'lng': '110.479921',
			'lat': '29.127401',
			'pinyin': 'Zhangjiajie',
			'initial': 'Z'
		},
		{
			'id': '440400',
			'name': '珠海市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '珠海',
			'leveltype': 2,
			'citycode': '0756',
			'zipcode': '519000',
			'mergername': '中国,广东省,珠海市',
			'lng': '113.552724',
			'lat': '22.255899',
			'pinyin': 'Zhuhai',
			'initial': 'Z'
		},
		{
			'id': '440800',
			'name': '湛江市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '湛江',
			'leveltype': 2,
			'citycode': '0759',
			'zipcode': '524047',
			'mergername': '中国,广东省,湛江市',
			'lng': '110.405529',
			'lat': '21.195338',
			'pinyin': 'Zhanjiang',
			'initial': 'Z'
		},
		{
			'id': '441200',
			'name': '肇庆市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '肇庆',
			'leveltype': 2,
			'citycode': '0758',
			'zipcode': '526040',
			'mergername': '中国,广东省,肇庆市',
			'lng': '112.472529',
			'lat': '23.051546',
			'pinyin': 'Zhaoqing',
			'initial': 'Z'
		},
		{
			'id': '442000',
			'name': '中山市',
			'areacode': null,
			'areaname': null,
			'pid': '440000',
			'shortname': '中山',
			'leveltype': 2,
			'citycode': '0760',
			'zipcode': '528403',
			'mergername': '中国,广东省,中山市',
			'lng': '113.382391',
			'lat': '22.521113',
			'pinyin': 'Zhongshan',
			'initial': 'Z'
		},
		{
			'id': '510300',
			'name': '自贡市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '自贡',
			'leveltype': 2,
			'citycode': '0813',
			'zipcode': '643000',
			'mergername': '中国,四川省,自贡市',
			'lng': '104.773447',
			'lat': '29.352765',
			'pinyin': 'Zigong',
			'initial': 'Z'
		},
		{
			'id': '512000',
			'name': '资阳市',
			'areacode': null,
			'areaname': null,
			'pid': '510000',
			'shortname': '资阳',
			'leveltype': 2,
			'citycode': '028',
			'zipcode': '641300',
			'mergername': '中国,四川省,资阳市',
			'lng': '104.641917',
			'lat': '30.122211',
			'pinyin': 'Ziyang',
			'initial': 'Z'
		},
		{
			'id': '520300',
			'name': '遵义市',
			'areacode': null,
			'areaname': null,
			'pid': '520000',
			'shortname': '遵义',
			'leveltype': 2,
			'citycode': '0852',
			'zipcode': '563000',
			'mergername': '中国,贵州省,遵义市',
			'lng': '106.937265',
			'lat': '27.706626',
			'pinyin': 'Zunyi',
			'initial': 'Z'
		},
		{
			'id': '530600',
			'name': '昭通市',
			'areacode': null,
			'areaname': null,
			'pid': '530000',
			'shortname': '昭通',
			'leveltype': 2,
			'citycode': '0870',
			'zipcode': '657000',
			'mergername': '中国,云南省,昭通市',
			'lng': '103.717216',
			'lat': '27.336999',
			'pinyin': 'Zhaotong',
			'initial': 'Z'
		},
		{
			'id': '620700',
			'name': '张掖市',
			'areacode': null,
			'areaname': null,
			'pid': '620000',
			'shortname': '张掖',
			'leveltype': 2,
			'citycode': '0936',
			'zipcode': '734000',
			'mergername': '中国,甘肃省,张掖市',
			'lng': '100.455472',
			'lat': '38.932897',
			'pinyin': 'Zhangye',
			'initial': 'Z'
		},
		{
			'id': '640500',
			'name': '中卫市',
			'areacode': null,
			'areaname': null,
			'pid': '640000',
			'shortname': '中卫',
			'leveltype': 2,
			'citycode': '0955',
			'zipcode': '751700',
			'mergername': '中国,宁夏回族自治区,中卫市',
			'lng': '105.189568',
			'lat': '37.514951',
			'pinyin': 'Zhongwei',
			'initial': 'Z'
		},
		{
			'id': '419000',
			'name': '直辖县级',
			'areacode': null,
			'areaname': null,
			'pid': '410000',
			'shortname': '直辖县',
			'leveltype': 2,
			'citycode': '0395',
			'zipcode': '462000',
			'mergername': '中国,河南省,直辖县级',
			'lng': '113.665412',
			'lat': '34.757975',
			'pinyin': 'Xian',
			'initial': 'Z'
		},
		{
			'id': '429000',
			'name': '直辖县级',
			'areacode': null,
			'areaname': null,
			'pid': '420000',
			'shortname': '直辖县',
			'leveltype': 2,
			'citycode': '0395',
			'zipcode': '462000',
			'mergername': '中国,湖北省,直辖县级',
			'lng': '114.298572',
			'lat': '30.584355',
			'pinyin': 'Xian',
			'initial': 'Z'
		},
		{
			'id': '469000',
			'name': '直辖县级',
			'areacode': null,
			'areaname': null,
			'pid': '460000',
			'shortname': '直辖县',
			'leveltype': 2,
			'citycode': '0395',
			'zipcode': '462000',
			'mergername': '中国,海南省,直辖县级',
			'lng': '109.503479',
			'lat': '18.739906',
			'pinyin': 'Xian',
			'initial': 'Z'
		},
		{
			'id': '659000',
			'name': '直辖县级',
			'areacode': null,
			'areaname': null,
			'pid': '650000',
			'shortname': '直辖县',
			'leveltype': 2,
			'citycode': '0395',
			'zipcode': '462000',
			'mergername': '中国,新疆维吾尔自治区,直辖县级',
			'lng': '91.132212',
			'lat': '29.660361',
			'pinyin': 'Xian',
			'initial': 'Z'
		}
	]
}
